import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Select,
  t,
  searchCustomerRows,
  mergeCustomerPins,
  addCustomerPin,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import PROVINCE from "../../assets/files/th_province.json";

// แท็บทั้งหมดของหน้าตั้งค่าใบงาน - เรียงตามลำดับที่แสดง (dataKey = state ที่ใช้โชว์จำนวนบน badge, ไม่มี = ไม่โชว์)
const SETTING_TABS = [
  { key: "category", label: "req_category", icon: "\uf02b", dataKey: "data_category" },
  { key: "service_type", label: "service_type", icon: "\uf0ad", dataKey: "data_service" },
  { key: "priority", label: "priority_level", icon: "\uf0e7", iconClass: "text-warning", dataKey: "data_priority" },
  { key: "reject_reason", label: "reject_reason", icon: "\uf00d", iconClass: "text-danger", dataKey: "data_reject" },
  { key: "email", label: "email_tab", icon: "\uf0e0", dataKey: "data_email" },
  { key: "machine_group", label: "machine_group_tab", icon: "\uf085", dataKey: "data_machine_group" },
  { key: "travel_allowance", label: "ta_tab", icon: "\uf1b9" },
  { key: "running_number", label: "rn_tab", icon: "\uf1c1" },
];

export default class WorkRequestConfig extends Component {
  constructor(props) {
    super(props);
    this.assetFormatInputRef = React.createRef();
    this.invoiceFormatInputRef = React.createRef();
    this.state = {
        active_tab: "category", // 'category' | 'service_type' | 'priority' | 'reject_reason' | 'travel_allowance' | 'running_number' | 'email' | 'machine_group'

        // Data Lists
        data_category: [],
        data_service: [],
        data_priority: [],
        data_reject: [],
        // แท็บอีเมล - ผู้รับสำเนาเอกสารงาน (ฝ่ายบัญชี) ถูก CC ทุกครั้งที่งานมีการชำระเงิน
        data_email: [],
        email_form: { uid: "", name: "", email: "", is_active: true },
        // แท็บจัดกลุ่มเครื่องจักร - ตัวเลือกช่อง "ระบบ" ในฟอร์มขึ้นทะเบียนเครื่องจักร
        data_machine_group: [],
        machine_group_form: { uid: "", code: "", name_th: "", name_en: "", is_active: true },
        filter_search: "",
        drag_item_id: null,
        drag_over_item_id: null,

        // Active Item for Form
        active_item: null,
        is_editing: false,

        // --- Form States ---
        name_th: "",
        name_en: "",
        description: "",
        icon: "",
        bg_color: "#ffe5e5",
        text_color: "#dc3545",
        is_active: true,

        // Category specific
        default_service_type: "",
        process_name: "",
        // ปุ่มเปิด/ปิดประเภทเอกสารตอนสร้าง WR ต่อหมวดหมู่ (work_requisition_categories.enable_*)
        enable_quotation: true,
        enable_sales_order: true,
        enable_work_order: true,

        // Service Type specific
        default_priority: "",

        // Priority specific
        label: "",
        response_time: "",
        sla_response_time_start_unit: "ชั่วโมง",
        resolution_time: "",
        sla_response_time_end_unit: "ชั่วโมง",
        notify_line: true,
        notify_email: true,
        escalate_sla: true,

        // Reject specific
        customer_advice: "",
        require_note: false,
        auto_notify: true,

        // Options for UI
        icons_list: ["\uf0e7", "\uf02f", "\uf043", "\uf0a1", "\uf013", "\uf0ad", "\uf073", "\uf040", "\uf071", "\uf00d", "\uf05e", "\uf022"],
        bg_colors: ["#ffe5e5", "#fff0e0", "#fff8cc", "#e0ebff", "#d1e7dd", "#f3e8ff", "#f8f9fa", "#ffffff"],
        text_colors: ["#dc3545", "#fd7e14", "#ffc107", "#0d6efd", "#198754", "#6f42c1", "#212529"],

        // --- Travel Allowance (UI only, no API yet) ---
        ta_payment_model: "distance", // 'distance' | 'per_trip' | 'per_day' | 'zone'
        ta_vehicle_personal_car: true,
        ta_vehicle_motorcycle: true,
        ta_vehicle_company_car: false,
        ta_rate_car_per_km: "5.00",
        ta_rate_car_min: "100",
        ta_rate_moto_per_km: "2.00",
        ta_rate_moto_min: "50",
        ta_force_odometer: true,
        ta_addon_tollway: true,
        ta_addon_parking: true,
        ta_addon_perdiem: true,
        ta_perdiem_amount: "300",
        ta_require_approval: true,

        // Per-trip lump sum rates + capped distance per vehicle
        ta_rate_per_trip_car: "500",
        ta_rate_per_trip_moto: "300",
        ta_cap_km_per_trip_car: "60",
        ta_cap_km_per_trip_moto: "60",

        // Per-day lump sum rates + capped distance per vehicle
        ta_rate_per_day_car: "500",
        ta_rate_per_day_moto: "300",
        ta_cap_km_per_day_car: "60",
        ta_cap_km_per_day_moto: "60",

        // Overage handling for per_trip / per_day models
        ta_overage_mode: "per_km", // 'per_km' | 'fixed_customer' | 'none'
        ta_overage_rate_car_per_km: "5.00",
        ta_overage_rate_moto_per_km: "2.00",
        ta_overage_fixed_fallback_amount: "300",

        // Zones (payment_model = 'zone')
        ta_zones: [],
        ta_zone_drag_item_id: null,
        ta_zone_drag_over_item_id: null,
        ta_zone_modal_open: false,
        ta_zone_editing: null, // uid of zone being edited, or null when creating
        ta_zone_name_th: "",
        ta_zone_icon: "",
        ta_zone_badge_color: "#e0ebff",
        ta_zone_distance_note: "",
        ta_zone_rate_per_trip: "",
        ta_zone_provinces: [], // ชื่อจังหวัด (ภาษาไทย) ที่เลือกไว้ - ต้องตรงกับ customers.province ถึงจะจับโซนได้

        // Simulator
        ta_sim_vehicle: "personal_car", // 'personal_car' | 'motorcycle' | 'company_car'
        ta_sim_distance: "0",
        ta_sim_customer: "",
        ta_customers: [],
        ta_customer_pins: [], // ลูกค้าที่เลือกในตัวจำลอง ต้องคงไว้แม้ผลค้นหาจะเปลี่ยน
        ta_loaded: false,

        // --- Running Number Settings ---
        asset_running_format: "",
        invoice_running_format: "",
        rn_loaded: false,
    };
  }

  async componentDidMount() {
    this.GetAll(); // ดึงข้อมูลทั้งหมดเพื่อโชว์ badge count
  }

  // --- API INTEGRATION ---

  getEndpoint = () => {
    const { active_tab } = this.state;
    switch (active_tab) {
      case "category": return "admin/work-requisition/categories";
      case "service_type": return "admin/work-requisition/service-types";
      case "priority": return "admin/work-requisition/priorities";
      case "reject_reason": return "admin/work-requisition/reject-reasons";
      default: return "";
    }
  };

  // สิทธิ์ของแท็บที่เลือก — prefix ตรงกับ checkPermission ของ route แต่ละแท็บ
  tabCan = (action) => {
    const prefix = {
      category: "wr-category",
      service_type: "wr-service-type",
      priority: "wr-priority",
      reject_reason: "wr-reject-reason",
    }[this.state.active_tab];
    return Boolean(prefix) && can(`${prefix}.${action}`);
  };

  sortBySequence = (items = []) => {
    return [...items].sort((a, b) => {
      const aSequence = Number(a?.sequence ?? 999999);
      const bSequence = Number(b?.sequence ?? 999999);
      if (aSequence !== bSequence) return aSequence - bSequence;

      const aName = `${a?.name_th || a?.label || ""}`.toLowerCase();
      const bName = `${b?.name_th || b?.label || ""}`.toLowerCase();
      return aName.localeCompare(bName);
    });
  };

  getCurrentDataKey = () => {
    const { active_tab } = this.state;
    if (active_tab === "category") return "data_category";
    if (active_tab === "service_type") return "data_service";
    if (active_tab === "priority") return "data_priority";
    if (active_tab === "reject_reason") return "data_reject";
    return "";
  };

  getPayloadByTab = (tab, item) => {
    if (tab === "reject_reason") {
      return {
        company_id: company?.id || "",
        sequence: item?.sequence || 1,
        name_th: item?.name_th || "",
        name_en: item?.name_en || "",
        description: item?.description || "",
        icon: item?.icon || "",
        background_color: item?.background_color || item?.bg_color || "#f8f9fa",
        is_reason_required: item?.is_reason_required || false,
        is_line_notify: item?.is_line_notify || false,
        is_email_notify: item?.is_email_notify || false,
        is_active: item?.is_active !== false,
      };
    }

    if (tab === "service_type") {
      return {
        company_id: company?.id || "",
        sequence: item?.sequence || 1,
        name_th: item?.name_th || "",
        name_en: item?.name_en || "",
        description: item?.description || "",
        background_color: item?.background_color || item?.bg_color || "#f8f9fa",
        priority_default_id: item?.priority_default?.uid || item?.priority_default_id || "",
        is_active: item?.is_active !== false,
      };
    }

    if (tab === "priority") {
      return {
        company_id: company?.id || "",
        sequence: item?.sequence || 1,
        name_th: item?.name_th || item?.label || "",
        name_en: item?.name_en || item?.label || item?.name_th || "",
        description: item?.description || "",
        icon: item?.icon || "",
        background_color: item?.background_color || item?.bg_color || "#f8f9fa",
        font_color: item?.font_color || item?.text_color || "#212529",
        sla_response_time_start: Number(item?.sla_response_time_start ?? item?.response_time ?? 0),
        sla_response_time_start_unit: item?.sla_response_time_start_unit || "ชั่วโมง",
        sla_response_time_end: Number(item?.sla_response_time_end ?? item?.resolution_time ?? 0),
        sla_response_time_end_unit: item?.sla_response_time_end_unit || "ชั่วโมง",
        is_line_notify: item?.is_line_notify || false,
        is_email_notify: item?.is_email_notify || false,
        is_escalate_notify: item?.is_escalate_notify || false,
        is_active: item?.is_active !== false,
      };
    }

    return {
      company_id: company?.id || "",
      sequence: item?.sequence || 1,
      name_th: item?.name_th || "",
      name_en: item?.name_en || "",
      description: item?.description || "",
      icon: item?.icon || "",
      background_color: item?.background_color || item?.bg_color || "#f8f9fa",
      service_type_default_id: item?.service_type_default?.uid || item?.service_type_default_id || "",
      is_active: item?.is_active !== false,
    };
  };

  GetAll = async () => {
    loading(true);
    // ดึงทั้งหมดพร้อมกันเพื่อแสดงตัวเลขที่แท็บ
    const endpoints = [
      "admin/work-requisition/categories",
      "admin/work-requisition/service-types",
      "admin/work-requisition/priorities",
      "admin/work-requisition/reject-reasons",
      "admin/email-recipients",
      "admin/machine-groups"
    ];

    const results = await Promise.all(
      endpoints.map(ep => GET(ep, { page_size: 100, page: 1 }))
    );

    this.setState({
      data_category: this.sortBySequence(results[0]?.status ? results[0].data : []),
      data_service: this.sortBySequence(results[1]?.status ? results[1].data : []),
      data_priority: this.sortBySequence(results[2]?.status ? results[2].data : []),
      data_reject: this.sortBySequence(results[3]?.status ? results[3].data : []),
      data_email: this.sortBySequence(results[4]?.status ? results[4].data : []),
      data_machine_group: this.sortBySequence(results[5]?.status ? results[5].data : []),
    });
    loading(false);
  };

  Get = async (page = 1) => {
    const { active_tab, filter_search } = this.state;
    loading(true);
    
    let result = await GET(this.getEndpoint(), {
      page_size: 100,
      page: page,
      data_search: filter_search || "",
    });

    if (result?.status) {
      const data = this.sortBySequence(result.data || []);
      if (active_tab === "category") this.setState({ data_category: data });
      else if (active_tab === "service_type") this.setState({ data_service: data });
      else if (active_tab === "priority") this.setState({ data_priority: data });
      else if (active_tab === "reject_reason") this.setState({ data_reject: data });
    }

    loading(false);
  };

  Save = async () => {
    const { 
      active_tab, active_item, name_th, name_en, description, 
      icon, bg_color, text_color, is_active, 
      default_service_type, default_priority, process_name, label, 
      response_time, sla_response_time_start_unit, sla_response_time_end_unit, resolution_time, customer_advice, require_note, auto_notify,
      notify_line, notify_email, escalate_sla 
    } = this.state;

    // Validation (ให้ Priority ใช้ name_en/label แทนการเช็ค name_th แบบแท็บอื่นได้)
    if (!name_th.trim() && active_tab !== 'priority') {
      alert("", "warning", t("warning"), t("please_fill_required"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_save_bom"), t("confirm"), t("cancel"))) {
        loading(true);

        const endpoint = this.getEndpoint();
        const uid = active_item?.id || active_item?.uid; // อิงตาม id หรือ uid ที่มาจาก API
        let body = {};

        // แมพค่า Body ให้ตรงกับแต่ละ Endpoint
        if (active_tab === "reject_reason") {
            body = {
                company_id: company?.id || "",
                sequence: active_item?.sequence || 1,
                name_th: name_th,
                name_en: name_en,
                description: customer_advice || description,
                icon: icon,
                background_color: bg_color,
                is_reason_required: require_note,
                is_line_notify: auto_notify,
                is_email_notify: auto_notify,
                is_active: is_active,
            };
        } else if (active_tab === "service_type") {
            body = {
                company_id: company?.id || "",
                sequence: active_item?.sequence || 1,
                name_th: name_th,
                name_en: name_en,
                description: description,
                background_color: bg_color,
                priority_default_id: default_priority || "",
                is_active: is_active,
            };
        } else if (active_tab === "priority") {
            body = {
                company_id: company?.id || "",
                sequence: active_item?.sequence || 1,
                name_th: name_th || label,
                name_en: name_en || label, // ใช้ label เป็นชื่อ EN หลักตาม mock data
                description: description,
                icon: icon,
                background_color: bg_color,
                font_color: text_color,
                sla_response_time_start: Number(response_time),
                sla_response_time_start_unit: sla_response_time_start_unit,
                sla_response_time_end: Number(resolution_time),
                sla_response_time_end_unit: sla_response_time_end_unit,
                is_line_notify: notify_line,
                is_email_notify: notify_email,
                is_escalate_notify: escalate_sla,
                is_active: is_active,
            };
        } else if (active_tab === "category") {
            body = {
                company_id: company?.id || "",
                sequence: active_item?.sequence || 1,
                name_th: name_th,
                name_en: name_en,
                description: description,
                icon: icon,
                background_color: bg_color,
                service_type_default_id: default_service_type || "",
                // ซ่อนช่องเลือก Process ในฟอร์มแล้ว (ไม่ได้ใช้) - ส่งค่าเดิมของรายการกลับไปเพื่อไม่ให้ค่าหาย
                process_name: process_name || "",
                // ปุ่มเปิด/ปิดประเภทเอกสารตอนสร้าง WR - ปิดไว้ = ปุ่มเลือกประเภทนั้นตอนสร้าง WR จะถูก disable
                enable_quotation: this.state.enable_quotation,
                enable_sales_order: this.state.enable_sales_order,
                enable_work_order: this.state.enable_work_order,
                is_active: is_active,
            };
        }

        // ตรวจสอบว่าเป็นการสร้างใหม่ (POST) หรืออัปเดต (PUT)
        let result = !uid ? await POST(endpoint, body) : await PUT(endpoint + "/" + uid, body);

        if (result?.status === true) {
            alert("", "success", t("success"), t("save_success"));
            this.setState({ is_editing: false, active_item: null });
            this.Get(1); // Refresh เฉพาะ Tab ปัจจุบัน
            this.GetAll(); // อัปเดต badge เผื่อมีจำนวนเปลี่ยนแปลง
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        loading(false);
    }
  };

  Delete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const endpoint = this.getEndpoint();
      let result = await DELETE(endpoint + "/" + id, null);
      
      if (result?.status) {
        alert("", "success", t("success"), t("delete_success"));
        this.Get(1);
        this.GetAll(); // อัปเดต badge
      } else {
         alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  // --- UI HANDLERS ---

  handleTabChange = (tab) => {
    this.setState({
      active_tab: tab,
      active_item: null,
      is_editing: false,
      name_th: "", name_en: "", description: ""
    }, () => {
      if (tab === "travel_allowance") {
        this.GetTravelAllowance(); // ดึง config ค่าเดินทาง + ลูกค้า
      } else if (tab === "running_number") {
        this.GetRunningNumberSettings();
      } else if (tab === "email") {
        this.GetEmailRecipients();
      } else if (tab === "machine_group") {
        this.GetMachineGroups();
      } else {
        this.Get(1); // ดึงข้อมูลของ tab ใหม่
      }
    });
  }

  handleSelectItem = (item) => {
    // นำค่าที่ดึงมาจาก API ไปแปะลงใน Form
    this.setState({
        active_item: item,
        is_editing: true,
        name_th: item.name_th || "",
        name_en: item.name_en || "",
        description: item.description || "",
        icon: item.icon || "\uf0e7",
        bg_color: item.background_color || item.bg_color || "#f8f9fa",
        text_color: item.font_color || item.text_color || "#212529",
        is_active: item.is_active !== false,

        label: item.name_th || item.label || "",
        response_time: item.sla_response_time_start ?? item.response_time ?? "",
        resolution_time: item.sla_response_time_end ?? item.resolution_time ?? "",
        sla_response_time_start_unit: item.sla_response_time_start_unit || "ชั่วโมง",
        sla_response_time_end_unit: item.sla_response_time_end_unit || "ชั่วโมง",
        notify_line: item.is_line_notify || false,
        notify_email: item.is_email_notify || false,
        escalate_sla: item.is_escalate_notify || false,

        customer_advice: item.description || item.customer_advice || "",
        require_note: item.is_reason_required || false,
        auto_notify: item.is_line_notify || false,

        default_service_type: item.service_type_default?.uid || "",
        default_priority: item.priority_default?.uid || "",
        process_name: item.process_name || "",
        // ไม่มีค่าจาก API (ยังไม่รัน migration) = ถือว่าเปิดทั้งหมดเหมือนเดิม
        enable_quotation: item.enable_quotation !== false,
        enable_sales_order: item.enable_sales_order !== false,
        enable_work_order: item.enable_work_order !== false,
    });
  }

  handleCreateNew = () => {
    this.setState({
      active_item: null,
      is_editing: true,
      name_th: "", name_en: "", description: "",
      icon: "\uf0e7", bg_color: "#f8f9fa", text_color: "#212529",
      is_active: true,
      label: "", response_time: "", resolution_time: "", customer_advice: "", 
      sla_response_time_start_unit: "ชั่วโมง", sla_response_time_end_unit: "ชั่วโมง",
      notify_line: true, notify_email: true, escalate_sla: true, require_note: false, auto_notify: true,
      default_service_type: "", default_priority: "", process_name: "",
      enable_quotation: true, enable_sales_order: true, enable_work_order: true,
    });
  }

  handleDragStart = (itemId) => {
    this.setState({ drag_item_id: itemId, drag_over_item_id: itemId });
  };

  handleDragOver = (e, itemId) => {
    e.preventDefault();
    if (this.state.drag_over_item_id !== itemId) {
      this.setState({ drag_over_item_id: itemId });
    }
  };

  handleDragEnd = () => {
    this.setState({ drag_item_id: null, drag_over_item_id: null });
  };

  reorderItems = (items, fromId, toId) => {
    const fromIndex = items.findIndex((item) => (item.id || item.uid) === fromId);
    const toIndex = items.findIndex((item) => (item.id || item.uid) === toId);
    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return null;

    const nextItems = [...items];
    const [movedItem] = nextItems.splice(fromIndex, 1);
    nextItems.splice(toIndex, 0, movedItem);

    return nextItems.map((item, index) => ({
      ...item,
      sequence: index + 1,
    }));
  };

  handleDrop = async (dropItemId) => {
    const { active_tab, drag_item_id, active_item } = this.state;
    if (!drag_item_id || drag_item_id === dropItemId) {
      this.handleDragEnd();
      return;
    }

    const dataKey = this.getCurrentDataKey();
    const currentItems = this.state[dataKey] || [];
    const reorderedItems = this.reorderItems(currentItems, drag_item_id, dropItemId);

    if (!reorderedItems) {
      this.handleDragEnd();
      return;
    }

    const activeItemId = active_item?.id || active_item?.uid;
    const updatedActiveItem = activeItemId
      ? reorderedItems.find((item) => (item.id || item.uid) === activeItemId) || active_item
      : active_item;

    this.setState({
      [dataKey]: reorderedItems,
      active_item: updatedActiveItem,
      drag_item_id: null,
      drag_over_item_id: null,
    });

    loading(true);
    try {
      const endpoint = this.getEndpoint();
      const results = await Promise.all(
        reorderedItems.map((item) => {
          const uid = item.uid || item.id;
          return PUT(`${endpoint}/${uid}`, this.getPayloadByTab(active_tab, item));
        })
      );
      if (results.some((result) => result?.status !== true)) {
        throw new Error("reorder_failed");
      }
      await this.Get(1);
      await this.GetAll();
    } catch (error) {
      alert("", "warning", t("warning"), t("error_occurred"));
      await this.Get(1);
    }
    loading(false);
  };

  getSlaUnitLabel = (unit) => {
    if (unit === "ชั่วโมง") return t("sla_unit_hour");
    if (unit === "วันทำการ") return t("sla_unit_business_day");
    return unit || "";
  }

  // --- RENDERERS ---

  renderLeftPanel = () => {
    const { active_tab, data_category, data_service, data_priority, data_reject, active_item, drag_over_item_id } = this.state;
    let data = [];
    let title = "";
    let warning_box = null;

    if (active_tab === "category") {
      data = data_category;
      title = t("req_category");
      warning_box = (
        <div className="bg-primary-light border border-primary rounded-3 p-2 mb-3 text-12 text-primary d-flex align-items-center">
          <span className="icon me-2">{"\uf0dc"}</span> {t("drag_to_reorder")}
        </div>
      );
    } else if (active_tab === "service_type") {
      data = data_service;
      title = t("service_type");
      warning_box = (
        <>
          <div className="bg-primary-light border border-primary rounded-3 p-2 mb-2 text-12 text-primary d-flex align-items-start">
            <span className="icon me-2">{"\uf05a"}</span> {t("service_type_warning")}
          </div>
        </>
      );
    } else if (active_tab === "priority") {
      data = data_priority;
      title = t("priority_level");
      warning_box = (
        <div className="bg-warning-light border border-warning rounded-3 p-2 mb-3 text-12 text-dark d-flex align-items-start">
          <span className="icon text-warning me-2">{"\uf071"}</span> {t("priority_fixed_warning")}
        </div>
      );
    } else if (active_tab === "reject_reason") {
      data = data_reject;
      title = t("reject_reason");
      warning_box = (
        <div className="bg-primary-light border border-primary rounded-3 p-2 mb-3 text-12 text-primary d-flex align-items-center">
          <span className="icon me-2">{"\uf05a"}</span> {t("reject_reason_warning")}
        </div>
      );
    }

    return (
      <div className="bg-white rounded-4 shadow-sm p-3 h-100">
        <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
          <div>
            <h6 className="fw-bold mb-1">{title}</h6>
            <div className="text-secondary text-10">{t("manage_items_desc")}</div>
          </div>
          {(active_tab !== "priority" || (active_tab === "priority" && data.length < 4))
            && (active_tab !== "service_type" || (active_tab === "service_type" && data.length < 3))
            && this.tabCan("create")
            && (
            <button className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-sm" onClick={this.handleCreateNew}>
              + {t("add")}
            </button>
          )}
        </div>

        {warning_box}

        <div className="d-flex flex-column gap-2 overflow-scroll" style={{ maxHeight: '60vh' }}>
          {data.map((item, idx) => {
            const itemId = item.id || item.uid; // จัดการ id/uid ตามที่ส่งกลับมาจาก API
            const activeItemId = active_item?.id || active_item?.uid;
            const isSelected = Boolean(activeItemId) && activeItemId === itemId;
            const isDropTarget = drag_over_item_id === itemId;
            const startUnitLabel = this.getSlaUnitLabel(item.sla_response_time_start_unit);
            const endUnitLabel = this.getSlaUnitLabel(item.sla_response_time_end_unit);
            return (
                <div
                    key={itemId}
                    className={`border rounded-3 p-2 d-flex align-items-center justify-content-between pointer transition-hover ${
                        isSelected ? "border-primary bg-primary-light shadow-sm" : "border bg-white"
                    }`}
                    style={
                      isSelected
                        ? undefined
                        : isDropTarget
                          ? { backgroundColor: "#F8FBFF", borderColor: "#93C5FD" }
                          : { backgroundColor: "#FFFFFF", borderColor: "#E9EDF7" }
                    }
                    onClick={() => this.handleSelectItem(item)}
                    draggable={this.tabCan("update")}
                    onDragStart={() => this.handleDragStart(itemId)}
                    onDragOver={(e) => this.handleDragOver(e, itemId)}
                    onDrop={() => this.handleDrop(itemId)}
                    onDragEnd={this.handleDragEnd}
                >
                    <div className="d-flex align-items-center">
                        <span className="icon text-secondary me-2 text-12">{"\uf142"}</span>
                        {item.icon ? (
                            <div
                                className="wpx-30 hpx-30 rounded-2 d-flex align-items-center justify-content-center me-3"
                                style={{ backgroundColor: item.background_color || item.bg_color || "#f8f9fa", color: item.font_color || item.text_color || "#212529" }}
                            >
                                <span className="icon text-14">{item.icon}</span>
                            </div>
                        ) : (
                            <div className="wpx-20 hpx-20 rounded-circle me-3" style={{ backgroundColor: item.background_color || item.bg_color || "#f8f9fa" }}></div>
                        )}

                        <div>
                            <div className="fw-bold text-dark text-14 d-flex align-items-center">
                                {item.name_th || item.label}
                                {item.is_fixed && (
                                    <>
                                        <span className="icon ms-2 text-secondary text-10" title={t("system_fixed")}>
                                            {"\uf023"}
                                        </span>
                                        <span className="text-secondary ms-1 text-10">{t("system_fixed")}</span>
                                    </>
                                )}
                            </div>
                            <div className="text-secondary text-10 text-truncate">
                                {item.sla_response_time_start
                                    ? `${t("sla")}: ${t("response_title")} ${item.sla_response_time_start}
                                ${item.sla_response_time_start == item.sla_response_time_end ? "" : `- ${item.sla_response_time_end}`} 
                                ${item.sla_response_time_start == item.sla_response_time_end ? startUnitLabel : endUnitLabel || startUnitLabel}`
                                    : ""}

                                {(active_tab === "service_type" || active_tab === "category" || active_tab === "reject_reason") && <>{item.name_en || ""}</>}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {item.count !== undefined && (
                            <div className="text-end d-none d-md-block">
                                <div className="text-dark text-12 fw-bold">{item.count} {t("wr_unit")}</div>
                                <div className="text-success text-10 d-flex align-items-center justify-content-end">
                                    <div className="wpx-6 hpx-6 rounded-circle bg-success me-1"></div>{t("active")}
                                </div>
                            </div>
                        )}
                        {active_tab === "reject_reason" && item.actual_qty !== undefined && (
                            <span className="badge bg-light text-secondary border rounded-pill px-2 py-1 fw-bold text-10">
                                {item.actual_qty} {t("times")}
                            </span>
                        )}
                        <span className="icon text-warning pointer hover-warning transition-hover">{"\uf044"}</span>
                        {!item.is_fixed && active_tab !== "priority" && active_tab !== "service_type" && this.tabCan("delete") && (
                            <span
                                className="icon text-secondary pointer hover-danger transition-hover"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.Delete(itemId);
                                }}
                            >
                                {"\uf2ed"}
                            </span>
                        )}
                    </div>
                </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderRightForm = () => {
    const { notify_line, notify_email, escalate_sla, active_tab, active_item, is_editing, name_th, name_en, description, icon, bg_color, text_color, is_active, icons_list, bg_colors, text_colors, default_service_type, default_priority, label, response_time, resolution_time, sla_response_time_start_unit, sla_response_time_end_unit, customer_advice, require_note, auto_notify, enable_quotation, enable_sales_order, enable_work_order } = this.state;

    if (!is_editing) {
      return (
        <div className="bg-white rounded-4 shadow-sm p-5 h-100 d-flex flex-column align-items-center justify-content-center text-center border">
          <span className="icon text-light text-60 mb-3">{"\uf044"}</span>
          <h5 className="fw-bold text-secondary">{t("select_item_to_edit")}</h5>
          <p className="text-secondary text-14">{t("or_click_add_new")}</p>
        </div>
      );
    }

    return (
        <div className="bg-white rounded-4 shadow-sm h-100 d-flex flex-column">
            {/* Form Header */}
            <div className="px-4 py-3 border-bottom bg-light rounded-top-4">
                <h5 className="fw-bold mb-1 text-dark d-flex align-items-center">
                    <span className="icon me-2 text-primary">{"\uf040"}</span>
                    {active_item ? `${t("edit")} ${t(active_tab)}` : `${t("add_new")} ${t(active_tab)}`}
                </h5>
                <div className="text-secondary text-12">{t("edit_info_and_save")}</div>
            </div>

            {/* Form Body */}
            <div className="p-4 flex-grow-1 overflow-scroll">
                {/* ----- PRIORITY TAB FIELDS ----- */}
                {active_tab === "priority" && (
                    <>
                        <div className="mb-3">
                            <label className="form-label text-dark fw-bold text-14">
                                {t("label_name")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control py-2" value={label} onChange={(e) => this.setState({ label: e.target.value })} disabled={active_item?.is_fixed} />
                            <div className="text-secondary text-10 mt-1">{t("label_desc")}</div>
                        </div>
                    </>
                )}

                {/* ----- COMMON NAME FIELDS ----- */}
                <div className="mb-3">
                    <label className="form-label text-dark fw-bold text-14">
                        {t("name_th")} {active_tab !== "priority" && <span className="text-danger">*</span>}
                    </label>
                    <input type="text" className="form-control py-2" value={name_th} onChange={(e) => this.setState({ name_th: e.target.value })} />
                </div>
                <div className="mb-3">
                    <label className="form-label text-dark fw-bold text-14">{t("name_en")}</label>
                    <input type="text" className="form-control py-2" value={name_en} onChange={(e) => this.setState({ name_en: e.target.value })} />
                </div>

                {/* ----- PRIORITY SLA CONFIG ----- */}
                {active_tab === "priority" && (
                    <div className="mb-4 bg-light rounded-3 p-3 border">
                        <h6 className="fw-bold text-dark text-14 mb-3 d-flex align-items-center">
                            <span className="icon me-2 text-secondary">{"\uf017"}</span> {t("sla_configuration")}
                        </h6>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label text-dark text-12 fw-bold">
                                    {t("response_time")} <span className="text-danger">*</span>
                                </label>
                                <div className="d-flex gap-2">
                                    <input type="number" className="form-control py-1" value={response_time} onChange={(e) => this.setState({ response_time: e.target.value })} />
                                    <Select
                                        className="form-control py-1 wpx-100"
                                        options={[
                                            { value: "ชั่วโมง", label: t("sla_unit_hour") },
                                            { value: "วันทำการ", label: t("sla_unit_business_day") },
                                        ]}
                                        value={sla_response_time_start_unit}
                                        onChange={(e) => this.setState({ sla_response_time_start_unit: e })}
                                        placeholder={t("sla_unit_hour")}
                                        default={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark text-12 fw-bold">{t("resolution_time")}</label>
                                <div className="d-flex gap-2">
                                    <input type="number" className="form-control py-1" value={resolution_time} onChange={(e) => this.setState({ resolution_time: e.target.value })} />
                                    <Select
                                        className="form-control py-1 wpx-100"
                                        options={[
                                            { value: "ชั่วโมง", label: t("sla_unit_hour") },
                                            { value: "วันทำการ", label: t("sla_unit_business_day") },
                                        ]}
                                        value={sla_response_time_end_unit}
                                        onChange={(e) => this.setState({ sla_response_time_end_unit: e })}
                                        placeholder={t("sla_unit_hour")}
                                        default={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ----- REJECT REASON SPECIFIC ----- */}
                {active_tab === "reject_reason" && (
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("customer_advice")}</label>
                        <textarea className="form-control py-2" rows="3" value={customer_advice} onChange={(e) => this.setState({ customer_advice: e.target.value })}></textarea>
                    </div>
                )}

                {/* ----- DESCRIPTION (Categories & Services) ----- */}
                {(active_tab === "category" || active_tab === "service_type") && (
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("description")}</label>
                        <textarea className="form-control py-2" rows="2" value={description} onChange={(e) => this.setState({ description: e.target.value })}></textarea>
                    </div>
                )}

                {/* ----- SERVICE TYPE DEFAULT (Categories) ----- */}
                {active_tab === "category" && (
                    <>
                        <div className="mb-3">
                            <label className="form-label text-dark fw-bold text-14">{t("service_type_default")}</label>
                            <Select
                                className="form-control"
                                options={this.state.data_service.map((svc) => ({ value: svc.uid || svc.id, label: svc.name_th }))}
                                value={default_service_type}
                                onChange={(e) => this.setState({ default_service_type: e })}
                                placeholder={t("select_service_type")}
                                defaultLabel={t("select_service_type")}
                            />
                        </div>
                    </>
                )}

                {/* ----- PRIORITY DEFAULT (Service Types) ----- */}
                {active_tab === "service_type" && (
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("priority_default")}</label>
                        <Select
                            className="form-control"
                            options={this.state.data_priority.map((prio) => ({ value: prio.uid || prio.id, label: prio.name_th }))}
                            value={default_priority}
                            onChange={(e) => this.setState({ default_priority: e })}
                            placeholder={t("select_priority")}
                            defaultLabel={t("select_priority")}
                        />
                        <div className="text-10 text-secondary mt-1">{t("priority_default_desc")}</div>
                    </div>
                )}

                {/* ----- ICONS (Category & Reject) ----- */}
                {(active_tab === "category" || active_tab === "reject_reason" || active_tab === "priority") && (
                    <div className="mb-4">
                        <label className="form-label text-dark fw-bold text-14">{t("icon")}</label>
                        <div className="d-flex flex-wrap gap-2">
                            {icons_list.map((ic, i) => (
                                <div
                                    key={i}
                                    className={`wpx-35 hpx-35 rounded-2 d-flex align-items-center justify-content-center pointer border transition-hover ${
                                        icon === ic ? "border-primary bg-primary-light text-primary" : "bg-white text-secondary hover-bg-light"
                                    }`}
                                    onClick={() => this.setState({ icon: ic })}
                                >
                                    <span className="icon text-16">{ic}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* ----- COLORS & PREVIEW ----- */}
                {active_tab !== "reject_reason" && (
                    <div className="mb-4">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold text-14">{t("bg_color")}</label>
                                <div className="d-flex flex-wrap gap-2">
                                    {bg_colors.map((c, i) => (
                                        <div
                                            key={i}
                                            className={`wpx-25 hpx-25 rounded-2 pointer border ${bg_color === c ? "border-dark shadow-sm" : "border-light"}`}
                                            style={{ backgroundColor: c }}
                                            onClick={() => this.setState({ bg_color: c })}
                                        ></div>
                                    ))}
                                </div>
                            </div>
                            {active_tab === "priority" && (
                                <div className="col-md-6">
                                    <label className="form-label text-dark fw-bold text-14">{t("text_color")}</label>
                                    <div className="d-flex flex-wrap gap-2">
                                        {text_colors.map((c, i) => (
                                            <div
                                                key={i}
                                                className={`wpx-25 hpx-25 rounded-2 pointer border ${text_color === c ? "border-dark shadow-sm" : "border-light"}`}
                                                style={{ backgroundColor: c }}
                                                onClick={() => this.setState({ text_color: c })}
                                            ></div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="mt-3">
                            <label className="form-label text-dark fw-bold text-14">{t("preview_badge")}</label>
                            <div className="p-3 rounded-3 d-flex align-items-center gap-3 border" style={{ backgroundColor: "#fafafa" }}>
                                <span
                                    className="badge rounded-pill fw-bold text-12 px-3 py-2 d-flex align-items-center"
                                    style={{ backgroundColor: bg_color, color: active_tab === "priority" ? text_color : "#212529" }}
                                >
                                    {(active_tab === "category" || active_tab === "reject_reason" || active_tab === "priority") && <span className="icon me-2">{icon}</span>}
                                    {label || name_th || t("preview")}
                                </span>
                                <span className="text-secondary text-10">{t("preview_desc")}</span>
                            </div>
                        </div>
                    </div>
                )}

                <hr className="my-4 border-light" />

                {/* ----- TOGGLES & DEFAULTS ----- */}

                {active_tab === "priority" && (
                    <div className="mb-4">
                        <label className="form-label text-dark fw-bold text-14">{t("notifications")}</label>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-14 text-dark d-flex align-items-center">
                                <span className="icon text-success me-2">{"\uf0f3"}</span> {t("notify_line")}
                            </span>
                            <div className="form-check form-switch">
                                <input className="form-check-input pointer" type="checkbox" checked={notify_line} onChange={(e) => this.setState({ notify_line: e.target.checked })} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-14 text-dark d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf0e0"}</span> {t("notify_email")}
                            </span>
                            <div className="form-check form-switch">
                                <input className="form-check-input pointer" type="checkbox" checked={notify_email} onChange={(e) => this.setState({ notify_email: e.target.checked })} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="text-14 text-dark d-flex align-items-center">
                                <span className="icon text-danger me-2">{"\uf017"}</span> {t("escalate_sla")}
                            </span>
                            <div className="form-check form-switch">
                                <input className="form-check-input pointer" type="checkbox" checked={escalate_sla} onChange={(e) => this.setState({ escalate_sla: e.target.checked })} />
                            </div>
                        </div>
                    </div>
                )}

                {active_tab === "reject_reason" && (
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <div className="text-14 text-dark fw-bold">{t("require_additional_note")}</div>
                                <div className="text-10 text-secondary">{t("require_note_desc")}</div>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input pointer" type="checkbox" checked={require_note} onChange={(e) => this.setState({ require_note: e.target.checked })} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <div className="text-14 text-dark fw-bold">{t("auto_notify_customer")}</div>
                                <div className="text-10 text-secondary">{t("auto_notify_desc")}</div>
                            </div>
                            <div className="form-check form-switch">
                                <input className="form-check-input pointer" type="checkbox" checked={auto_notify} onChange={(e) => this.setState({ auto_notify: e.target.checked })} />
                            </div>
                        </div>
                    </div>
                )}

                {/* ----- DOCUMENT TYPE TOGGLES (Category only) ----- */}
                {active_tab === "category" && (
                    <div className="mb-4">
                        <label className="form-label text-dark fw-bold text-14">{t("document_type_settings")}</label>
                        <div className="border rounded-3 overflow-hidden">
                            <div className="d-flex justify-content-between align-items-center px-3 py-2">
                                <span className="text-14 text-dark fw-bold">
                                    {t("doc_type_quotation")}<span className="text-secondary fw-normal"> / Quotation</span>
                                </span>
                                <div className="form-check form-switch m-0">
                                    <input className="form-check-input pointer" type="checkbox" checked={enable_quotation} onChange={(e) => this.setState({ enable_quotation: e.target.checked })} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top">
                                <span className="text-14 text-dark fw-bold">
                                    {t("doc_type_sales_order")}<span className="text-secondary fw-normal"> / Sale Order</span>
                                </span>
                                <div className="form-check form-switch m-0">
                                    <input className="form-check-input pointer" type="checkbox" checked={enable_sales_order} onChange={(e) => this.setState({ enable_sales_order: e.target.checked })} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top">
                                <span className="text-14 text-dark fw-bold">
                                    {t("doc_type_work_order")}<span className="text-secondary fw-normal"> / Work Order</span>
                                </span>
                                <div className="form-check form-switch m-0">
                                    <input className="form-check-input pointer" type="checkbox" checked={enable_work_order} onChange={(e) => this.setState({ enable_work_order: e.target.checked })} />
                                </div>
                            </div>
                        </div>
                        <div className="text-10 text-secondary mt-1">{t("document_type_settings_desc")}</div>
                    </div>
                )}

                <div className="d-flex justify-content-between align-items-center">
                    <span className="text-14 fw-bold text-dark">{t("status_active")}</span>
                    <div className="form-check form-switch m-0">
                        <input
                            className="form-check-input fs-5 pointer"
                            type="checkbox"
                            checked={is_active}
                            onChange={(e) => this.setState({ is_active: e.target.checked })}
                            disabled={active_item?.is_fixed}
                        />
                    </div>
                </div>
            </div>

            {/* Form Footer */}
            <div className="p-3 border-top bg-light rounded-bottom-4 d-flex justify-content-end gap-2">
                <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ is_editing: false, active_item: null })}>
                    {t("cancel")}
                </button>
                {this.tabCan(active_item?.id || active_item?.uid ? "update" : "create") && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        onClick={this.Save}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                )}
            </div>
        </div>
    );
  }

  // --- TRAVEL ALLOWANCE API ---

  toTaCustomerOption = (customer) => ({
    ...customer,
    value: customer.uid,
    label: (customer.customer_code ? `${customer.customer_code} - ` : "") + (customer.full_name_th || customer.full_name_en || customer.alias_name || "-"),
  });

  // ค้นหาลูกค้าฝั่ง server (Select เรียกให้ตอนพิมพ์) - token กันผลลัพธ์ที่ตอบช้ามาทับคำค้นล่าสุด
  taCustomerSearchToken = 0;

  searchTaCustomers = async (keyword = "") => {
    const token = ++this.taCustomerSearchToken;
    const rows = await searchCustomerRows(keyword);
    if (token !== this.taCustomerSearchToken || rows === null) return;

    this.setState((prevState) => ({
      ta_customers: mergeCustomerPins(rows.map(this.toTaCustomerOption), prevState.ta_customer_pins),
    }));
  };

  // ลูกค้าที่เลือกในตัวจำลองต้องอยู่ในรายการเสมอ เพราะสูตรคำนวณอ่านข้อมูลลูกค้าจาก ta_customers
  pinTaCustomer = (option) => {
    if (!option?.value) return;

    this.setState((prevState) => {
      const ta_customer_pins = addCustomerPin(prevState.ta_customer_pins, option);
      return { ta_customer_pins, ta_customers: mergeCustomerPins(prevState.ta_customers, ta_customer_pins) };
    });
  };

  TA_ENDPOINT = "admin/work-requisition/travel-allowance";
  TA_ZONES_ENDPOINT = "admin/work-requisition/travel-allowance/zones";

  // โหลด config ค่าเดินทาง + โซน (ลูกค้าค้นหาฝั่ง server ตอนพิมพ์ ไม่โหลดยกก้อน)
  GetTravelAllowance = async () => {
    loading(true);
    const [configRes, zonesRes] = await Promise.all([GET(this.TA_ENDPOINT, {}), GET(this.TA_ZONES_ENDPOINT, {})]);

    if (!this.state.ta_loaded) this.searchTaCustomers("");

    const next = {};
    const cfg = configRes?.status ? configRes.data : null;
    if (cfg) {
      next.ta_payment_model = cfg.payment_model || "distance";
      next.ta_vehicle_personal_car = cfg.vehicle_personal_car_enabled !== false;
      next.ta_vehicle_motorcycle = cfg.vehicle_motorcycle_enabled !== false;
      next.ta_vehicle_company_car = cfg.vehicle_company_car_enabled === true;
      next.ta_rate_car_per_km = String(cfg.rate_car_per_km ?? "");
      next.ta_rate_car_min = String(cfg.rate_car_min ?? "");
      next.ta_rate_moto_per_km = String(cfg.rate_moto_per_km ?? "");
      next.ta_rate_moto_min = String(cfg.rate_moto_min ?? "");
      next.ta_force_odometer = cfg.force_odometer !== false;

      next.ta_rate_per_trip_car = String(cfg.rate_per_trip_car ?? "");
      next.ta_rate_per_trip_moto = String(cfg.rate_per_trip_moto ?? "");
      next.ta_cap_km_per_trip_car = String(cfg.cap_km_per_trip_car ?? "");
      next.ta_cap_km_per_trip_moto = String(cfg.cap_km_per_trip_moto ?? "");

      next.ta_rate_per_day_car = String(cfg.rate_per_day_car ?? "");
      next.ta_rate_per_day_moto = String(cfg.rate_per_day_moto ?? "");
      next.ta_cap_km_per_day_car = String(cfg.cap_km_per_day_car ?? "");
      next.ta_cap_km_per_day_moto = String(cfg.cap_km_per_day_moto ?? "");

      next.ta_overage_mode = cfg.overage_mode || "per_km";
      next.ta_overage_rate_car_per_km = String(cfg.overage_rate_car_per_km ?? "");
      next.ta_overage_rate_moto_per_km = String(cfg.overage_rate_moto_per_km ?? "");
      next.ta_overage_fixed_fallback_amount = String(cfg.overage_fixed_fallback_amount ?? "");

      next.ta_addon_tollway = cfg.addon_tollway !== false;
      next.ta_addon_parking = cfg.addon_parking !== false;
      next.ta_addon_perdiem = cfg.addon_perdiem !== false;
      next.ta_perdiem_amount = String(cfg.perdiem_amount ?? "");
      next.ta_require_approval = cfg.require_approval !== false;
    }

    next.ta_zones = zonesRes?.status ? this.sortBySequence(zonesRes.data || []) : [];

    next.ta_loaded = true;

    this.setState(next);
    loading(false);
  };

  SaveTravelAllowance = async () => {
    if (!(await alert("", "info", t("confirm"), t("confirm_save_bom"), t("confirm"), t("cancel")))) return;

    loading(true);
    const body = {
      payment_model: this.state.ta_payment_model,
      vehicle_personal_car_enabled: this.state.ta_vehicle_personal_car,
      vehicle_motorcycle_enabled: this.state.ta_vehicle_motorcycle,
      vehicle_company_car_enabled: this.state.ta_vehicle_company_car,
      rate_car_per_km: Number(this.state.ta_rate_car_per_km) || 0,
      rate_car_min: Number(this.state.ta_rate_car_min) || 0,
      rate_moto_per_km: Number(this.state.ta_rate_moto_per_km) || 0,
      rate_moto_min: Number(this.state.ta_rate_moto_min) || 0,
      force_odometer: this.state.ta_force_odometer,

      rate_per_trip_car: Number(this.state.ta_rate_per_trip_car) || 0,
      rate_per_trip_moto: Number(this.state.ta_rate_per_trip_moto) || 0,
      cap_km_per_trip_car: Number(this.state.ta_cap_km_per_trip_car) || 0,
      cap_km_per_trip_moto: Number(this.state.ta_cap_km_per_trip_moto) || 0,

      rate_per_day_car: Number(this.state.ta_rate_per_day_car) || 0,
      rate_per_day_moto: Number(this.state.ta_rate_per_day_moto) || 0,
      cap_km_per_day_car: Number(this.state.ta_cap_km_per_day_car) || 0,
      cap_km_per_day_moto: Number(this.state.ta_cap_km_per_day_moto) || 0,

      overage_mode: this.state.ta_overage_mode,
      overage_rate_car_per_km: Number(this.state.ta_overage_rate_car_per_km) || 0,
      overage_rate_moto_per_km: Number(this.state.ta_overage_rate_moto_per_km) || 0,
      overage_fixed_fallback_amount: Number(this.state.ta_overage_fixed_fallback_amount) || 0,

      addon_tollway: this.state.ta_addon_tollway,
      addon_parking: this.state.ta_addon_parking,
      addon_perdiem: this.state.ta_addon_perdiem,
      perdiem_amount: Number(this.state.ta_perdiem_amount) || 0,
      require_approval: this.state.ta_require_approval,
    };

    const result = await PUT(this.TA_ENDPOINT, body);
    if (result?.status === true) {
      alert("", "success", t("success"), t("save_success"));
      await this.GetTravelAllowance();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  // --- TRAVEL ALLOWANCE ZONES (CRUD + drag reorder) ---

  handleZoneOpenCreate = () => {
    this.setState({
      ta_zone_modal_open: true,
      ta_zone_editing: null,
      ta_zone_name_th: "",
      ta_zone_icon: "",
      ta_zone_badge_color: "#e0ebff",
      ta_zone_distance_note: "",
      ta_zone_rate_per_trip: "",
      ta_zone_provinces: [],
    });
  };

  handleZoneOpenEdit = (zone) => {
    this.setState({
      ta_zone_modal_open: true,
      ta_zone_editing: zone.uid || zone.id,
      ta_zone_name_th: zone.name_th || "",
      ta_zone_icon: zone.icon || "",
      ta_zone_badge_color: zone.badge_color || "#e0ebff",
      ta_zone_distance_note: zone.distance_note || "",
      ta_zone_rate_per_trip: String(zone.rate_per_trip ?? ""),
      ta_zone_provinces: Array.isArray(zone.provinces) ? zone.provinces.filter(Boolean) : [],
    });
  };

  handleZoneModalClose = () => {
    this.setState({ ta_zone_modal_open: false, ta_zone_editing: null });
  };

  // เพิ่มจังหวัดเข้าโซนที่กำลังแก้ไข - กันเลือกซ้ำ และกันจังหวัดที่ถูกใช้ในโซนอื่นไปแล้ว (โซนแรกที่ตรงจะชนะเสมอ)
  handleZoneProvinceAdd = (province) => {
    if (!province) return;
    const { ta_zone_provinces, ta_zones, ta_zone_editing } = this.state;
    if (ta_zone_provinces.includes(province)) return;

    const usedByOtherZone = (ta_zones || []).find((zone) =>
      (zone.uid || zone.id) !== ta_zone_editing
      && Array.isArray(zone.provinces)
      && zone.provinces.includes(province)
    );
    if (usedByOtherZone) {
      alert("", "warning", t("warning"), `${t("ta_zone_province_duplicate")} (${usedByOtherZone.name_th})`);
      return;
    }

    this.setState({ ta_zone_provinces: [...ta_zone_provinces, province] });
  };

  handleZoneProvinceRemove = (province) => {
    this.setState({ ta_zone_provinces: this.state.ta_zone_provinces.filter((item) => item !== province) });
  };

  SaveZone = async () => {
    const {
      ta_zone_editing, ta_zone_name_th, ta_zone_icon, ta_zone_badge_color,
      ta_zone_distance_note, ta_zone_rate_per_trip, ta_zone_provinces,
    } = this.state;

    if (!ta_zone_name_th.trim()) {
      alert("", "warning", t("warning"), t("please_fill_required"));
      return;
    }

    loading(true);
    const body = {
      company_id: company?.id || "",
      name_th: ta_zone_name_th.trim(),
      icon: ta_zone_icon || "",
      badge_color: ta_zone_badge_color || "",
      distance_note: ta_zone_distance_note || "",
      rate_per_trip: Number(ta_zone_rate_per_trip) || 0,
      provinces: ta_zone_provinces.filter(Boolean),
    };

    const result = !ta_zone_editing
      ? await POST(this.TA_ZONES_ENDPOINT, body)
      : await PUT(`${this.TA_ZONES_ENDPOINT}/${ta_zone_editing}`, body);

    if (result?.status === true) {
      alert("", "success", t("success"), t("save_success"));
      this.setState({ ta_zone_modal_open: false, ta_zone_editing: null });
      this.GetTravelAllowance();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  DeleteZone = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE(`${this.TA_ZONES_ENDPOINT}/${uid}`, null);
      if (result?.status) {
        alert("", "success", t("success"), t("delete_success"));
        this.GetTravelAllowance();
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  handleZoneDragStart = (itemId) => {
    this.setState({ ta_zone_drag_item_id: itemId, ta_zone_drag_over_item_id: itemId });
  };

  handleZoneDragOver = (e, itemId) => {
    e.preventDefault();
    if (this.state.ta_zone_drag_over_item_id !== itemId) {
      this.setState({ ta_zone_drag_over_item_id: itemId });
    }
  };

  handleZoneDragEnd = () => {
    this.setState({ ta_zone_drag_item_id: null, ta_zone_drag_over_item_id: null });
  };

  handleZoneDrop = async (dropItemId) => {
    const { ta_zone_drag_item_id, ta_zones } = this.state;
    if (!ta_zone_drag_item_id || ta_zone_drag_item_id === dropItemId) {
      this.handleZoneDragEnd();
      return;
    }

    const reordered = this.reorderItems(ta_zones, ta_zone_drag_item_id, dropItemId);
    if (!reordered) {
      this.handleZoneDragEnd();
      return;
    }

    this.setState({ ta_zones: reordered, ta_zone_drag_item_id: null, ta_zone_drag_over_item_id: null });

    loading(true);
    try {
      const results = await Promise.all(
        reordered.map((zone) => PUT(`${this.TA_ZONES_ENDPOINT}/${zone.uid || zone.id}`, {
          company_id: company?.id || "",
          sequence: zone.sequence,
          name_th: zone.name_th || "",
          icon: zone.icon || "",
          badge_color: zone.badge_color || "",
          distance_note: zone.distance_note || "",
          rate_per_trip: Number(zone.rate_per_trip) || 0,
          provinces: Array.isArray(zone.provinces) ? zone.provinces : [],
        }))
      );
      if (results.some((r) => r?.status !== true)) throw new Error("reorder_failed");
    } catch (error) {
      alert("", "warning", t("warning"), t("error_occurred"));
      await this.GetTravelAllowance();
    }
    loading(false);
  };

  // --- TRAVEL ALLOWANCE (UI) ---

  renderTaSectionHeader = (number, title, desc) => (
    <div className="d-flex align-items-start mb-3">
      <span
        className="d-flex align-items-center justify-content-center rounded-2 fw-bold text-white me-3 flex-shrink-0"
        style={{ width: 26, height: 26, backgroundColor: "#2563eb", fontSize: 13 }}
      >
        {number}
      </span>
      <div>
        <h6 className="fw-bold mb-1 text-dark">{title}</h6>
        <div className="text-secondary text-12">{desc}</div>
      </div>
    </div>
  );

  renderTaToggleRow = (icon, iconColor, title, desc, stateKey, onLabel, offLabel) => {
    const checked = this.state[stateKey];
    return (
      <div className="d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-start">
          {icon && (
            <span className={`icon me-3 text-16 ${iconColor || "text-secondary"}`}>{icon}</span>
          )}
          <div>
            <div className="fw-bold text-dark text-14">{title}</div>
            {desc && <div className="text-secondary text-12">{desc}</div>}
          </div>
        </div>
        <div className="d-flex align-items-center gap-4">
          {(onLabel || offLabel) && (
            <span className={`text-12 fw-bold  ${checked ? "text-success" : "text-secondary"}`}>
              {checked ? onLabel : offLabel}
            </span>
          )}
          <div className="form-check form-switch m-0">
            <input
              className="form-check-input fs-5 pointer"
              type="checkbox"
              checked={checked}
              onChange={(e) => this.setState({ [stateKey]: e.target.checked })}
            />
          </div>
        </div>
      </div>
    );
  };

  // รายการพาหนะที่เปิดจ่ายค่าเดินทาง (ใช้สร้าง dropdown ของ Simulator)
  getTravelVehicleOptions = () => {
    const { ta_vehicle_personal_car, ta_vehicle_motorcycle, ta_vehicle_company_car } = this.state;
    const opts = [];
    if (ta_vehicle_personal_car) opts.push({ key: "personal_car", label: t("ta_vehicle_personal_car"), icon: "\uf1b9" });
    if (ta_vehicle_motorcycle) opts.push({ key: "motorcycle", label: t("ta_vehicle_motorcycle"), icon: "\uf21c" });
    if (ta_vehicle_company_car) opts.push({ key: "company_car", label: t("ta_vehicle_company_car"), icon: "\uf0d1" });
    return opts;
  };

  // ค่าเดินทางสรุป — แปรผันตามโมเดลการจ่าย, พาหนะ และระยะทางที่เลือก
  computeTravelSimulator = () => {
    const {
      ta_payment_model, ta_sim_distance, ta_sim_vehicle, ta_sim_customer, ta_customers,
      ta_rate_car_per_km, ta_rate_car_min, ta_rate_moto_per_km, ta_rate_moto_min,
      ta_rate_per_trip_car, ta_rate_per_trip_moto, ta_cap_km_per_trip_car, ta_cap_km_per_trip_moto,
      ta_rate_per_day_car, ta_rate_per_day_moto, ta_cap_km_per_day_car, ta_cap_km_per_day_moto,
      ta_overage_mode, ta_overage_rate_car_per_km, ta_overage_rate_moto_per_km, ta_overage_fixed_fallback_amount,
      ta_vehicle_personal_car, ta_vehicle_motorcycle, ta_vehicle_company_car,
      ta_zones,
    } = this.state;

    const options = this.getTravelVehicleOptions();
    // ถ้าพาหนะที่เลือกถูกปิดไป ให้ fallback มาที่ตัวแรกที่ยังเปิดอยู่
    const vehicle = options.some((o) => o.key === ta_sim_vehicle)
      ? ta_sim_vehicle
      : (options[0]?.key || null);

    const distance = Number(ta_sim_distance) || 0;
    const isMoto = vehicle === "motorcycle";
    const isCompany = vehicle === "company_car";

    // รถบริษัท: บริษัทออกน้ำมัน/Fleet Card → ไม่จ่ายค่าระยะทาง
    const paidVehicle =
      vehicle === "personal_car" ? ta_vehicle_personal_car :
      vehicle === "motorcycle" ? ta_vehicle_motorcycle :
      vehicle === "company_car" ? ta_vehicle_company_car : false;

    const base = {
      vehicle, distance, isMoto, isCompany, paidVehicle,
      model: ta_payment_model,
      noVehicle: options.length === 0,
    };

    // ไม่มีพาหนะให้เลือก หรือพาหนะที่เลือกไม่จ่ายค่าเดินทาง (รวมถึงรถบริษัท) → 0 เสมอ ทุกโมเดล
    if (options.length === 0 || !paidVehicle || isCompany) {
      return { ...base, total: 0 };
    }

    const selectedCustomer = (ta_customers || []).find((c) => c.uid === ta_sim_customer) || null;

    if (ta_payment_model === "distance") {
      const rate = Number(isMoto ? ta_rate_moto_per_km : ta_rate_car_per_km) || 0;
      const min = Number(isMoto ? ta_rate_moto_min : ta_rate_car_min) || 0;
      const raw = distance * rate;
      const total = Math.max(raw, min);
      return { ...base, rate, min, raw, total, appliedMin: raw < min };
    }

    if (ta_payment_model === "per_trip" || ta_payment_model === "per_day") {
      const isTrip = ta_payment_model === "per_trip";
      const rate = Number(isMoto
        ? (isTrip ? ta_rate_per_trip_moto : ta_rate_per_day_moto)
        : (isTrip ? ta_rate_per_trip_car : ta_rate_per_day_car)) || 0;
      const capKm = Number(isMoto
        ? (isTrip ? ta_cap_km_per_trip_moto : ta_cap_km_per_day_moto)
        : (isTrip ? ta_cap_km_per_trip_car : ta_cap_km_per_day_car)) || 0;

      const overageDistance = Math.max(0, distance - capKm);
      let overageAmount = 0;
      let usedCustomerFallback = false;

      if (overageDistance > 0) {
        if (ta_overage_mode === "per_km") {
          const overageRate = Number(isMoto ? ta_overage_rate_moto_per_km : ta_overage_rate_car_per_km) || 0;
          overageAmount = overageDistance * overageRate;
        } else if (ta_overage_mode === "fixed_customer") {
          const customerRate = selectedCustomer?.travel_rate_per_trip;
          usedCustomerFallback = customerRate === undefined || customerRate === null;
          overageAmount = Number(customerRate ?? ta_overage_fixed_fallback_amount) || 0;
        }
      }

      return {
        ...base, rate, capKm, overageDistance, overageAmount, usedCustomerFallback,
        overageMode: ta_overage_mode, total: rate + overageAmount,
      };
    }

    if (ta_payment_model === "zone") {
      // ไม่ตรงโซนไหนเลย = ไม่คิดค่าเดินทาง (ไม่เดาโซนแรกให้) เพราะจะทำให้ประเมินราคาผิดโดยไม่รู้ตัว
      const targetProvince = String(selectedCustomer?.province || company?.province || "").trim().toLowerCase();
      const zone = targetProvince
        ? (ta_zones || []).find((z) => Array.isArray(z.provinces) && z.provinces.some((p) => String(p).trim().toLowerCase() === targetProvince))
        : null;
      return { ...base, zone: zone || null, zoneAuto: Boolean(zone), total: Number(zone?.rate_per_trip || 0) };
    }

    return { ...base, total: 0 };
  };

  // Section 3 variant for the per_trip / per_day payment models.
  renderTaTripDayConfig = (model) => {
    const isTrip = model === "per_trip";
    const rateCarKey = isTrip ? "ta_rate_per_trip_car" : "ta_rate_per_day_car";
    const rateMotoKey = isTrip ? "ta_rate_per_trip_moto" : "ta_rate_per_day_moto";
    const capCarKey = isTrip ? "ta_cap_km_per_trip_car" : "ta_cap_km_per_day_car";
    const capMotoKey = isTrip ? "ta_cap_km_per_trip_moto" : "ta_cap_km_per_day_moto";

    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
        {this.renderTaSectionHeader("3", isTrip ? t("ta_trip_config_title") : t("ta_day_config_title"), isTrip ? t("ta_trip_config_desc") : t("ta_day_config_desc"))}
        <div className="table-responsive">
          <table className="table table-borderless align-middle mb-0">
            <thead>
              <tr className="text-secondary text-12">
                <th className="fw-bold ps-0">{t("ta_col_vehicle")}</th>
                <th className="fw-bold">{isTrip ? t("ta_col_rate_per_trip") : t("ta_col_rate_per_day")} <span className="text-danger">*</span></th>
                <th className="fw-bold">{t("ta_col_cap_km")} <span className="text-danger">*</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="ps-0 text-14 fw-bold text-dark">
                  <span className="icon text-primary me-2">{""}</span> {t("ta_vehicle_personal_car")}
                </td>
                <td>
                  <input type="number" className="form-control py-2" value={this.state[rateCarKey]} onChange={(e) => this.setState({ [rateCarKey]: e.target.value })} />
                </td>
                <td>
                  <input type="number" className="form-control py-2" value={this.state[capCarKey]} onChange={(e) => this.setState({ [capCarKey]: e.target.value })} />
                </td>
              </tr>
              <tr>
                <td className="ps-0 text-14 fw-bold text-dark">
                  <span className="icon text-primary me-2">{""}</span> {t("ta_vehicle_motorcycle")}
                </td>
                <td>
                  <input type="number" className="form-control py-2" value={this.state[rateMotoKey]} onChange={(e) => this.setState({ [rateMotoKey]: e.target.value })} />
                </td>
                <td>
                  <input type="number" className="form-control py-2" value={this.state[capMotoKey]} onChange={(e) => this.setState({ [capMotoKey]: e.target.value })} />
                </td>
              </tr>
              <tr>
                <td className="ps-0 text-14 fw-bold text-secondary">
                  <span className="icon text-secondary me-2">{""}</span> {t("ta_vehicle_company_car")}
                </td>
                <td colSpan="2" className="text-secondary text-12">{t("ta_company_car_distance_note")}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="text-secondary text-10 mt-2 d-flex align-items-start">
          <span className="icon me-1">{""}</span> {t("ta_trip_config_rationale")}
        </div>
      </div>
    );
  };

  // A number input with a unit suffix rendered as a single merged box.
  // (Plain bootstrap .input-group doesn't merge here because a global style.css rule
  // forces `.form-control { border-radius: 12px !important; }` on every corner.)
  renderTaUnitInput = (value, onChange, unitLabel) => (
    <div className="border rounded-3 d-flex align-items-center bg-white" style={{ borderColor: "#ced4da" }}>
      <input
        type="number"
        className="form-control shadow-none py-1"
        style={{ border: 0, borderRadius: 0, backgroundColor: "transparent" }}
        value={value}
        onChange={onChange}
      />
      <span className="text-secondary text-12 text-nowrap pe-2 ps-1">{unitLabel}</span>
    </div>
  );

  // Section 4: how overage beyond the capped distance gets paid (only for per_trip / per_day).
  renderTaOverageConfig = () => {
    const { ta_overage_mode, ta_overage_rate_car_per_km, ta_overage_rate_moto_per_km, ta_overage_fixed_fallback_amount } = this.state;

    const options = [
      { key: "per_km", title: t("ta_overage_per_km_title"), desc: t("ta_overage_per_km_desc") },
      { key: "fixed_customer", title: t("ta_overage_fixed_title"), desc: t("ta_overage_fixed_desc") },
      { key: "none", title: t("ta_overage_none_title"), desc: t("ta_overage_none_desc") },
    ];

    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
        {this.renderTaSectionHeader("4", t("ta_overage_title"), t("ta_overage_desc"))}
        <div className="d-flex flex-column gap-3">
          {options.map((opt) => {
            const selected = ta_overage_mode === opt.key;
            return (
              <div
                key={opt.key}
                className={`border rounded-3 p-3 pointer transition-hover ${selected ? "border-primary bg-primary-light shadow-sm" : "border bg-white hover-bg-light"}`}
                style={selected ? undefined : { borderColor: "#E9EDF7" }}
                onClick={() => this.setState({ ta_overage_mode: opt.key })}
              >
                <div className="d-flex align-items-start">
                  <span className={`form-check-input rounded-circle m-0 me-3 mt-1 flex-shrink-0 ${selected ? "bg-primary border-primary" : ""}`} style={{ width: 18, height: 18 }}></span>
                  <div className="flex-grow-1">
                    <div className="fw-bold text-dark text-14 mb-1">{opt.title}</div>
                    <div className="text-secondary text-12">{opt.desc}</div>

                    {selected && opt.key === "per_km" && (
                      <div className="row g-2 mt-2" onClick={(e) => e.stopPropagation()}>
                        <div className="col-6 col-md-4">
                          <label className="form-label text-dark text-12 fw-bold d-flex align-items-center">
                            <span className="icon text-primary me-1">{"\uf1b9"}</span> {t("ta_vehicle_personal_car")}
                          </label>
                          {this.renderTaUnitInput(ta_overage_rate_car_per_km, (e) => this.setState({ ta_overage_rate_car_per_km: e.target.value }), t("ta_per_km_unit"))}
                        </div>
                        <div className="col-6 col-md-4">
                          <label className="form-label text-dark text-12 fw-bold d-flex align-items-center">
                            <span className="icon text-primary me-1">{"\uf21c"}</span> {t("ta_vehicle_motorcycle")}
                          </label>
                          {this.renderTaUnitInput(ta_overage_rate_moto_per_km, (e) => this.setState({ ta_overage_rate_moto_per_km: e.target.value }), t("ta_per_km_unit"))}
                        </div>
                      </div>
                    )}

                    {selected && opt.key === "fixed_customer" && (
                      <div className="row g-2 mt-2" onClick={(e) => e.stopPropagation()}>
                        <div className="col-6 col-md-4">
                          <label className="form-label text-dark text-12 fw-bold">{t("ta_overage_fallback_label")}</label>
                          {this.renderTaUnitInput(ta_overage_fixed_fallback_amount, (e) => this.setState({ ta_overage_fixed_fallback_amount: e.target.value }), t("ta_overage_fallback_unit"))}
                        </div>
                        <div className="col-12 text-secondary text-10 mt-1 d-flex align-items-start">
                          <span className="icon me-1">{"\uf0eb"}</span> {t("ta_overage_fixed_rationale")}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Section 3 variant for the zone payment model: draggable ordered list of zones.
  renderTaZoneConfig = () => {
    const { ta_zones, ta_zone_drag_over_item_id } = this.state;

    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-start">
            <span
              className="d-flex align-items-center justify-content-center rounded-2 fw-bold text-white me-3 flex-shrink-0"
              style={{ width: 26, height: 26, backgroundColor: "#2563eb", fontSize: 13 }}
            >
              3
            </span>
            <div>
              <h6 className="fw-bold mb-1 text-dark">
                {t("ta_zone_config_title")}{" "}
              </h6>
              <div className="text-secondary text-12">{t("ta_zone_config_desc")}</div>
            </div>
          </div>
          {can("wr-travel-allowance.create") && (
            <button className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-sm text-nowrap" onClick={this.handleZoneOpenCreate}>
              + {t("ta_zone_add")}
            </button>
          )}
        </div>

        <div className="d-flex flex-column gap-2">
          {(ta_zones || []).map((zone) => {
            const zoneId = zone.uid || zone.id;
            const isDropTarget = ta_zone_drag_over_item_id === zoneId;
            return (
              <div
                key={zoneId}
                className="border rounded-3 p-2 d-flex align-items-center justify-content-between"
                style={isDropTarget ? { backgroundColor: "#F8FBFF", borderColor: "#93C5FD" } : { backgroundColor: "#FFFFFF", borderColor: "#E9EDF7" }}
                draggable={can("wr-travel-allowance.update")}
                onDragStart={() => this.handleZoneDragStart(zoneId)}
                onDragOver={(e) => this.handleZoneDragOver(e, zoneId)}
                onDrop={() => this.handleZoneDrop(zoneId)}
                onDragEnd={this.handleZoneDragEnd}
              >
                <div className="d-flex align-items-center">
                  <span className="icon text-secondary me-2 text-12">{""}</span>
                  <div
                    className="wpx-35 hpx-35 rounded-2 d-flex align-items-center justify-content-center me-3"
                    style={{ backgroundColor: zone.badge_color || "#eef2ff" }}
                  >
                    <span className="icon text-16">{zone.icon || ""}</span>
                  </div>
                  <div>
                    <div className="fw-bold text-dark text-14">{zone.name_th}</div>
                    {zone.distance_note && <div className="text-secondary text-10">{zone.distance_note}</div>}
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <span className="badge bg-light text-dark border rounded-pill px-3 py-2 fw-bold text-12">
                    {t("currency_baht_symbol")}{Number(zone.rate_per_trip || 0).toLocaleString('en-US')} / {t("ta_km_trip_unit")}
                  </span>
                  <span className="icon text-warning pointer hover-warning transition-hover" onClick={() => this.handleZoneOpenEdit(zone)}>{""}</span>
                  {can("wr-travel-allowance.delete") && (
                    <span className="icon text-secondary pointer hover-danger transition-hover" onClick={() => this.DeleteZone(zoneId)}>{""}</span>
                  )}
                </div>
              </div>
            );
          })}
          {(!ta_zones || ta_zones.length === 0) && (
            <div className="text-secondary text-12 text-center py-3">{t("ta_zone_empty")}</div>
          )}
        </div>
      </div>
    );
  };

  renderZoneModal = () => {
    const { ta_zone_modal_open, ta_zone_editing, ta_zone_name_th, ta_zone_distance_note, ta_zone_rate_per_trip, ta_zone_provinces } = this.state;
    if (!ta_zone_modal_open) return null;

    return (
      <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.4)" }} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0 pb-0">
              <h5 className="fw-bold text-dark">{ta_zone_editing ? t("ta_zone_edit_title") : t("ta_zone_add_title")}</h5>
              <button type="button" className="btn-close" onClick={this.handleZoneModalClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-14">{t("ta_zone_name_label")} <span className="text-danger">*</span></label>
                <input type="text" className="form-control py-2" value={ta_zone_name_th} onChange={(e) => this.setState({ ta_zone_name_th: e.target.value })} />
              </div>
              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-14">{t("ta_zone_distance_note_label")}</label>
                <input type="text" className="form-control py-2" value={ta_zone_distance_note} onChange={(e) => this.setState({ ta_zone_distance_note: e.target.value })} placeholder={t("ta_zone_distance_note_placeholder")} />
              </div>
              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-14">{t("ta_zone_rate_label")} <span className="text-danger">*</span></label>
                <input type="number" className="form-control py-2" value={ta_zone_rate_per_trip} onChange={(e) => this.setState({ ta_zone_rate_per_trip: e.target.value })} />
              </div>
              <div className="mb-1">
                <label className="form-label text-dark fw-bold text-14">{t("ta_zone_provinces_label")}</label>
                <Select
                  className="form-control"
                  options={PROVINCE
                    .filter((e) => !ta_zone_provinces.includes(e.th))
                    .map((e) => ({ value: e.th, label: e.th }))}
                  value=""
                  onChange={(value) => this.handleZoneProvinceAdd(value)}
                  placeholder={t("ta_zone_provinces_placeholder")}
                />
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {ta_zone_provinces.map((province) => (
                    <span key={province} className="badge bg-light text-dark border rounded-pill px-3 py-2 fw-bold text-12 d-flex align-items-center">
                      {province}
                      <span className="icon text-secondary pointer hover-danger transition-hover ms-2 text-10" onClick={() => this.handleZoneProvinceRemove(province)}>{""}</span>
                    </span>
                  ))}
                  {ta_zone_provinces.length === 0 && (
                    <span className="text-secondary text-12">{t("ta_zone_provinces_empty")}</span>
                  )}
                </div>
                <div className="text-secondary text-10 mt-1">{t("ta_zone_provinces_desc")}</div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.handleZoneModalClose}>{t("cancel")}</button>
              {(ta_zone_editing ? can("wr-travel-allowance.update") : can("wr-travel-allowance.create")) && (
                <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm" onClick={this.SaveZone}>{t("save")}</button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTravelAllowance = () => {
    const {
      ta_payment_model, ta_rate_car_per_km, ta_rate_car_min, ta_rate_moto_per_km, ta_rate_moto_min,
      ta_perdiem_amount, ta_sim_distance, ta_sim_customer, ta_customers,
    } = this.state;

    const vehicle_options = this.getTravelVehicleOptions();

    const payment_models = [
      { key: "distance", icon: "\uf018", title: t("ta_model_distance"), desc: t("ta_model_distance_desc") },
      { key: "per_trip", icon: "\uf0d1", title: t("ta_model_per_trip"), desc: t("ta_model_per_trip_desc") },
      { key: "per_day", icon: "\uf073", title: t("ta_model_per_day"), desc: t("ta_model_per_day_desc") },
      { key: "zone", icon: "\uf3c5", title: t("ta_model_zone"), desc: t("ta_model_zone_desc") },
    ];

    const sim = this.computeTravelSimulator();
    const money = (n) => `${t("currency_baht_symbol")}${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    return (
      <>
        {/* Info Banner */}
        <div className="bg-primary-light border border-primary rounded-3 p-3 mb-4 text-12 text-primary d-flex align-items-start">
          <span className="icon me-2">{"\uf05a"}</span>
          <div>{t("ta_info_banner")}</div>
        </div>

        <div className="row g-4">
          {/* LEFT: Config sections */}
          <div className="col-lg-8">
            {/* Section 1: Payment Model */}
            <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
              {this.renderTaSectionHeader("1", t("ta_payment_model_title"), t("ta_payment_model_desc"))}
              <div className="row g-3">
                {payment_models.map((m) => {
                  const selected = ta_payment_model === m.key;
                  return (
                    <div className="col-md-6 col-xxl-3" key={m.key}>
                      <div
                        className={`border rounded-3 p-3 pointer h-100 position-relative transition-hover ${
                          selected ? "border-primary bg-primary-light shadow-sm" : "border bg-white hover-bg-light"
                        }`}
                        style={selected ? undefined : { borderColor: "#E9EDF7" }}
                        onClick={() => this.setState({ ta_payment_model: m.key })}
                      >
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div
                            className="wpx-35 hpx-35 rounded-2 d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: selected ? "#2563eb" : "#eef2ff", color: selected ? "#ffffff" : "#2563eb" }}
                          >
                            <span className="icon text-16">{m.icon}</span>
                          </div>
                          <span className={`form-check-input rounded-circle m-0 ${selected ? "bg-primary border-primary" : ""}`} style={{ width: 18, height: 18 }}></span>
                        </div>
                        <div className="fw-bold text-dark text-14 mb-1">{m.title}</div>
                        <div className="text-secondary text-12">{m.desc}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-secondary text-10 mt-3 d-flex align-items-start">
                <span className="icon me-1">{"\uf0eb"}</span> {t("ta_model_rationale")}
              </div>
            </div>

            {/* Section 2: Vehicle Type */}
            <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
              {this.renderTaSectionHeader("2", t("ta_vehicle_title"), t("ta_vehicle_desc"))}
              <div className="d-flex flex-column">
                {this.renderTaToggleRow("\uf1b9", "text-primary", t("ta_vehicle_personal_car"), t("ta_vehicle_personal_car_desc"), "ta_vehicle_personal_car", t("ta_pay_travel"), t("ta_no_pay"))}
                <hr className="my-1 border-light" />
                {this.renderTaToggleRow("\uf21c", "text-primary", t("ta_vehicle_motorcycle"), t("ta_vehicle_motorcycle_desc"), "ta_vehicle_motorcycle", t("ta_pay_travel"), t("ta_no_pay"))}
                <hr className="my-1 border-light" />
                {this.renderTaToggleRow("\uf0d1", "text-secondary", t("ta_vehicle_company_car"), t("ta_vehicle_company_car_desc"), "ta_vehicle_company_car", t("ta_pay_travel"), t("ta_no_pay"))}
              </div>
              <div className="text-secondary text-10 mt-3 d-flex align-items-start">
                <span className="icon me-1">{"\uf0eb"}</span> {t("ta_vehicle_rationale")}
              </div>
            </div>

            {/* Section 3: Distance config (only for distance model) */}
            {ta_payment_model === "distance" && (
              <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
                {this.renderTaSectionHeader("3", t("ta_distance_config_title"), t("ta_distance_config_desc"))}
                <div className="table-responsive">
                  <table className="table table-borderless align-middle mb-0">
                    <thead>
                      <tr className="text-secondary text-12">
                        <th className="fw-bold ps-0">{t("ta_col_vehicle")}</th>
                        <th className="fw-bold">{t("ta_col_rate_per_km")} <span className="text-danger">*</span></th>
                        <th className="fw-bold">{t("ta_col_min_per_trip")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="ps-0 text-14 fw-bold text-dark">
                          <span className="icon text-primary me-2">{"\uf1b9"}</span> {t("ta_vehicle_personal_car")}
                        </td>
                        <td>
                          <input type="number" className="form-control py-2" value={ta_rate_car_per_km} onChange={(e) => this.setState({ ta_rate_car_per_km: e.target.value })} />
                        </td>
                        <td>
                          <input type="number" className="form-control py-2" value={ta_rate_car_min} onChange={(e) => this.setState({ ta_rate_car_min: e.target.value })} />
                        </td>
                      </tr>
                      <tr>
                        <td className="ps-0 text-14 fw-bold text-dark">
                          <span className="icon text-primary me-2">{"\uf21c"}</span> {t("ta_vehicle_motorcycle")}
                        </td>
                        <td>
                          <input type="number" className="form-control py-2" value={ta_rate_moto_per_km} onChange={(e) => this.setState({ ta_rate_moto_per_km: e.target.value })} />
                        </td>
                        <td>
                          <input type="number" className="form-control py-2" value={ta_rate_moto_min} onChange={(e) => this.setState({ ta_rate_moto_min: e.target.value })} />
                        </td>
                      </tr>
                      <tr>
                        <td className="ps-0 text-14 fw-bold text-secondary">
                          <span className="icon text-secondary me-2">{"\uf0d1"}</span> {t("ta_vehicle_company_car")}
                        </td>
                        <td colSpan="2" className="text-secondary text-12">{t("ta_company_car_distance_note")}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="text-secondary text-10 mt-2 mb-3 d-flex align-items-start">
                  <span className="icon me-1">{"\uf05a"}</span> {t("ta_distance_reference")}
                </div>
                <hr className="my-3 border-light" />
                {this.renderTaToggleRow(null, null, t("ta_force_odometer"), null, "ta_force_odometer")}
                <div className="text-secondary text-10 mt-2 d-flex align-items-start">
                  <span className="icon me-1">{"\uf0eb"}</span> {t("ta_force_odometer_rationale")}
                </div>
              </div>
            )}

            {/* Section 3: Per-trip / Per-day config */}
            {(ta_payment_model === "per_trip" || ta_payment_model === "per_day") && this.renderTaTripDayConfig(ta_payment_model)}

            {/* Section 3: Zone config */}
            {ta_payment_model === "zone" && this.renderTaZoneConfig()}

            {/* Section 4: Overage handling (only applies to per_trip / per_day) */}
            {(ta_payment_model === "per_trip" || ta_payment_model === "per_day") && this.renderTaOverageConfig()}

            {/* Section 5: Add-on Reimbursement */}
            <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
              {this.renderTaSectionHeader("5", t("ta_addon_title"), t("ta_addon_desc"))}
              <div className="d-flex flex-column">
                {this.renderTaToggleRow("\uf018", "text-primary", t("ta_addon_tollway"), null, "ta_addon_tollway")}
                <hr className="my-1 border-light" />
                {this.renderTaToggleRow("\uf540", "text-primary", t("ta_addon_parking"), null, "ta_addon_parking")}
                <hr className="my-1 border-light" />
                {this.renderTaToggleRow("\uf0d6", "text-warning", t("ta_addon_perdiem"), null, "ta_addon_perdiem")}
                {this.state.ta_addon_perdiem && (
                  <div className="d-flex align-items-center gap-2 ms-5 mb-2">
                    <input
                      type="number"
                      className="form-control py-1 wpx-100"
                      value={ta_perdiem_amount}
                      onChange={(e) => this.setState({ ta_perdiem_amount: e.target.value })}
                    />
                    <span className="text-secondary text-12">{t("ta_perdiem_unit")}</span>
                  </div>
                )}
                <hr className="my-1 border-light" />
                {this.renderTaToggleRow("\uf00c", "text-success", t("ta_require_approval"), null, "ta_require_approval")}
              </div>
              <div className="text-secondary text-10 mt-3 d-flex align-items-start">
                <span className="icon me-1">{"\uf0eb"}</span> {t("ta_approval_rationale")}
              </div>
            </div>

            {/* Footer Save */}
            <div className="d-flex justify-content-end gap-2 mb-4">
              {can("wr-travel-allowance.update") && (
                <button
                  className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                  onClick={this.SaveTravelAllowance}
                >
                  <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                </button>
              )}
            </div>
          </div>

          {/* RIGHT: Simulator */}
          <div className="col-lg-4">
            <div className="bg-white rounded-4 shadow-sm p-4 border" style={{ position: "sticky", top: 20 }}>
              <h6 className="fw-bold mb-1 text-dark d-flex align-items-center">
                <span className="icon me-2 text-primary">{"\uf1ec"}</span> {t("ta_simulator_title")}
              </h6>
              <div className="text-secondary text-12 mb-3">{t("ta_simulator_desc")}</div>

              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-12">{t("ta_sim_vehicle_label")}</label>
                <Select
                  className="form-control py-2"
                  options={vehicle_options.map((o) => ({ value: o.key, label: o.label }))}
                  value={sim.vehicle || ""}
                  disabled={vehicle_options.length === 0}
                  onChange={(e) => this.setState({ ta_sim_vehicle: e })}
                  placeholder="-"
                  default={false}
                />
              </div>

              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-12">{t("ta_sim_distance_label")}</label>
                <input type="number" min="0" className="form-control py-2" value={ta_sim_distance} onChange={(e) => this.setState({ ta_sim_distance: e.target.value })} />
              </div>

              <div className="mb-3">
                <label className="form-label text-dark fw-bold text-12">{t("ta_sim_customer_label")}</label>
                <Select
                  className="form-control"
                  options={ta_customers || []}
                  onSearch={this.searchTaCustomers}
                  value={ta_sim_customer}
                  onChange={(e, i) => {
                    this.pinTaCustomer(i);
                    this.setState({ ta_sim_customer: e });
                  }}
                  placeholder={t("ta_sim_use_default")}
                />
                {ta_sim_customer && (
                  <div className="text-secondary text-10 mt-1 d-flex align-items-start">
                    <span className="icon me-1">{"\uf05a"}</span> {t("ta_sim_customer_default_note")}
                  </div>
                )}
              </div>

              <hr className="border-light" />

              {/* TA_SUMMARY_BLOCK */}
              {sim.noVehicle ? (
                <div className="text-secondary text-12 text-center py-3">{t("ta_sim_no_vehicle")}</div>
              ) : (
                <>
                  <div className="d-flex align-items-center mb-2">
                    <span className="icon text-primary me-2">{sim.isCompany ? "\uf0d1" : sim.isMoto ? "\uf21c" : "\uf1b9"}</span>
                    <span className="fw-bold text-14 text-dark">
                      {sim.isCompany ? t("ta_vehicle_company_car") : sim.isMoto ? t("ta_vehicle_motorcycle") : t("ta_vehicle_personal_car")}
                    </span>
                  </div>

                  {!sim.paidVehicle || sim.isCompany ? (
                    <div className="d-flex justify-content-between align-items-center text-14 mb-2 text-secondary">
                      <span>{t("ta_no_pay")}</span>
                      <span className="fw-bold">{money(0)}</span>
                    </div>
                  ) : sim.model === "distance" ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center text-14 mb-2">
                        <span className="text-secondary">{sim.distance} {t("ta_km")} {"×"} {money(sim.rate)}</span>
                        <span className="fw-bold text-dark">{money(sim.raw)}</span>
                      </div>
                      {sim.appliedMin && (
                        <div className="d-flex justify-content-between align-items-center text-12 mb-2 text-warning">
                          <span>{t("ta_min_applied")}</span>
                          <span className="fw-bold">{money(sim.min)}</span>
                        </div>
                      )}
                    </>
                  ) : sim.model === "per_trip" || sim.model === "per_day" ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center text-14 mb-2">
                        <span className="text-secondary">
                          {sim.model === "per_trip" ? t("ta_sim_rate_per_trip_label") : t("ta_sim_rate_per_day_label")} ({t("ta_sim_cap_label")} {sim.capKm} {t("ta_km")})
                        </span>
                        <span className="fw-bold text-dark">{money(sim.rate)}</span>
                      </div>
                      {sim.overageDistance > 0 && (
                        <div className="d-flex justify-content-between align-items-center text-12 mb-2 text-warning">
                          <span>{t("ta_sim_overage_label")} {sim.overageDistance} {t("ta_km")}</span>
                          <span className="fw-bold">{money(sim.overageAmount)}</span>
                        </div>
                      )}
                      {sim.usedCustomerFallback && (
                        <div className="text-secondary text-10 mb-2">{t("ta_sim_used_fallback_note")}</div>
                      )}
                    </>
                  ) : sim.model === "zone" ? (
                    sim.zone ? (
                      <div className="d-flex justify-content-between align-items-center text-14 mb-2">
                        <span className="text-secondary">
                          {t("ta_sim_zone_label")}: {sim.zone.name_th}
                          {sim.zoneAuto && <span className="text-10"> ({t("ta_sim_zone_auto")})</span>}
                        </span>
                        <span className="fw-bold text-dark">{money(sim.zone.rate_per_trip)}</span>
                      </div>
                    ) : (
                      <div className="bg-light border rounded-3 p-2 mb-2 text-12 text-secondary">{t("ta_sim_no_zone")}</div>
                    )
                  ) : null}

                  <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                    <span className="fw-bold text-success">{t("ta_sim_total")}</span>
                    <span className="fw-bold text-success text-18">{money(sim.total)}</span>
                  </div>
                </>
              )}

              <div className="bg-warning-light border border-warning rounded-3 p-2 mt-3 text-10 text-dark d-flex align-items-start">
                <span className="icon text-warning me-2 mt-1">{"\uf071"}</span>
                <div>{t("ta_sim_warning")}</div>
              </div>
            </div>
          </div>
        </div>

        {this.renderZoneModal()}
      </>
    );
  };

  // --- RUNNING NUMBER SETTINGS ---

  RN_ENDPOINT = "admin/company/running-number";

  // คีย์รูปแบบที่ใช้แทรกใน asset_running_format / invoice_running_format
  // supported: true = backend รองรับแทนค่าจริง (ดู generateAssetCode), false = ยังไม่มี logic รองรับ จะถูกบันทึกเป็นข้อความตรงตัว
  // conditional: true = ค่าถูกดึงจากข้อมูลจริงตอนสร้าง asset (department.department_code, coi_date)
  //   ถ้าข้อมูลนั้นไม่มี ระบบจะแจ้งเตือน "ไม่พบข้อมูล" และสร้าง asset ไม่ได้ (ไม่ใช่ปล่อยผ่านเป็นข้อความตรงตัว)
  // {site_code} เป็นชื่อที่ใช้แสดงผลเท่านั้น: ค่าที่บันทึก/ใช้งานจริงฝั่ง backend ยังเป็น {department_code}
  //   (แปลงไป-กลับตอนโหลด/บันทึก ดู toDisplayRunningFormat / toStoredRunningFormat)
  getRunningFormatKeys = () => [
    { key: "site_code", desc: t("rn_key_department_code_desc"), supported: true, conditional: true },
    { key: "machine_group_code", desc: t("rn_key_machine_group_code_desc"), supported: true, conditional: true },
    { key: "yyyy_ts", desc: t("rn_key_yyyy_ts_desc"), supported: true },
    { key: "yyyy_eoi", desc: t("rn_key_yyyy_eoi_desc"), supported: true, conditional: true },
    { key: "mm_ts", desc: t("rn_key_mm_ts_desc"), supported: true },
    { key: "mm_eoi", desc: t("rn_key_mm_eoi_desc"), supported: true, conditional: true },
    { key: "running_2", desc: t("rn_key_running_2_desc"), supported: true, isRunning: true },
    { key: "running_3", desc: t("rn_key_running_3_desc"), supported: true, isRunning: true },
    { key: "running_4", desc: t("rn_key_running_4_desc"), supported: true, isRunning: true },
    { key: "running_5", desc: t("rn_key_running_5_desc"), supported: true, isRunning: true },
    { key: "running_6", desc: t("rn_key_running_6_desc"), supported: true, isRunning: true },
  ];

  RN_DEFAULT_FORMAT = "{yyyy_ts}-{mm_ts}-{running_4}";

  toDisplayRunningFormat = (format) => (format || "").replace(/\{department_code\}/g, "{site_code}");

  toStoredRunningFormat = (format) => (format || "").replace(/\{site_code\}/g, "{department_code}");

  GetRunningNumberSettings = async () => {
    loading(true);
    const result = await GET(this.RN_ENDPOINT, {});
    if (result?.status) {
      this.setState({
        asset_running_format: this.toDisplayRunningFormat(result.data?.asset_running_format || this.RN_DEFAULT_FORMAT),
        invoice_running_format: this.toDisplayRunningFormat(result.data?.invoice_running_format || this.RN_DEFAULT_FORMAT),
        rn_loaded: true,
      });
    }
    loading(false);
  };

  // ต้องมี {running_2|3|4|5|6} เพียงตัวเดียวในทั้งสตริง และต้องอยู่ท้ายสุดเสมอ
  isValidRunningFormat = (format) => {
    const matches = format.match(/\{running_\d+\}/g) || [];
    return matches.length === 1 && /\{running_[23456]\}$/.test(format);
  };

  SaveRunningNumberSettings = async () => {
    const { asset_running_format, invoice_running_format } = this.state;
    const asset = asset_running_format.trim();
    const invoice = invoice_running_format.trim();

    if (!asset) {
      alert("", "warning", t("warning"), t("verify_asset_running_format"));
      return;
    } else if (!invoice) {
      alert("", "warning", t("warning"), t("verify_invoice_running_format"));
      return;
    } else if (!this.isValidRunningFormat(asset)) {
      alert("", "warning", t("warning"), t("verify_asset_running_format_suffix"));
      return;
    } else if (!this.isValidRunningFormat(invoice)) {
      alert("", "warning", t("warning"), t("verify_invoice_running_format_suffix"));
      return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_save_bom"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT(this.RN_ENDPOINT, {
      asset_running_format: this.toStoredRunningFormat(asset),
      invoice_running_format: this.toStoredRunningFormat(invoice),
    });

    if (result?.status === true) {
      alert("", "success", t("success"), t("save_success"));
      await this.GetRunningNumberSettings();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  // แทรกคีย์รูปแบบ (เช่น {running_4}) ที่ตำแหน่งเคอร์เซอร์ของ input นั้นๆ
  insertFormatKey = (field, ref, key) => {
    const current = this.state[field] || "";
    const token = `{${key}}`;
    const input = ref.current;

    if (!input) {
      this.setState({ [field]: current + token });
      return;
    }

    const start = input.selectionStart ?? current.length;
    const end = input.selectionEnd ?? current.length;
    const next = current.slice(0, start) + token + current.slice(end);

    this.setState({ [field]: next }, () => {
      const pos = start + token.length;
      input.focus();
      input.setSelectionRange(pos, pos);
    });
  };

  // กด Backspace/Delete ติดกับคีย์ที่แทรกไว้ (เช่น {running_4}) ให้ลบทั้งก้อนในครั้งเดียว
  // แทนที่จะต้องกดหลายครั้งทีละตัวอักษร (ถ้ามีการเลือกข้อความอยู่ ปล่อยให้ลบตามปกติ)
  handleFormatKeyDown = (field, e) => {
    if (e.key !== "Backspace" && e.key !== "Delete") return;

    const input = e.target;
    if (input.selectionStart !== input.selectionEnd) return;

    const value = this.state[field] || "";
    const pos = input.selectionStart;

    if (e.key === "Backspace") {
      const match = value.slice(0, pos).match(/\{[a-zA-Z0-9_]+\}$/);
      if (!match) return;

      e.preventDefault();
      const newPos = pos - match[0].length;
      const next = value.slice(0, newPos) + value.slice(pos);
      this.setState({ [field]: next }, () => {
        input.focus();
        input.setSelectionRange(newPos, newPos);
      });
    } else {
      const match = value.slice(pos).match(/^\{[a-zA-Z0-9_]+\}/);
      if (!match) return;

      e.preventDefault();
      const next = value.slice(0, pos) + value.slice(pos + match[0].length);
      this.setState({ [field]: next }, () => {
        input.focus();
        input.setSelectionRange(pos, pos);
      });
    }
  };

  // แปลงรูปแบบเป็นตัวอย่างข้อความจริง: {running_x} จะถูกแทนด้วยเลข 1 (เติม 0 ตามความยาว)
  // {yyyy_ts}/{mm_ts} แทนด้วยปี พ.ศ./เดือนปัจจุบัน (ตรงกับ logic ฝั่ง backend)
  // {site_code}/{yyyy_eoi}/{mm_eoi} เป็นค่าจริงจากข้อมูล asset ตอนสร้าง
  // จึงแสดงเป็นตัวอย่างสมมติเท่านั้น พร้อม flag เตือนว่าต้องมีข้อมูลจริงตอนสร้าง asset
  buildFormatPreview = (format) => {
    const value = format || "";
    const tokens = value.split(/(\{[a-zA-Z0-9_]+\})/g).filter((tok) => tok !== "");
    let hasUnsupported = false;
    let hasConditional = false;

    const now = new Date();
    const buddhistYear = String(now.getFullYear() + 543);
    const month = String(now.getMonth() + 1).padStart(2, "0");

    const conditionalSamples = {
      site_code: "SITE01",
      department_code: "SITE01",
      machine_group_code: "GRP01",
      yyyy_eoi: buddhistYear,
      mm_eoi: month,
    };

    const text = tokens
      .map((tok) => {
        const match = tok.match(/^\{([a-zA-Z0-9_]+)\}$/);
        if (!match) return tok;

        const runningMatch = match[1].match(/^running_(\d+)$/);
        if (runningMatch) {
          return "1".padStart(Number(runningMatch[1]), "0");
        }

        if (match[1] === "yyyy_ts") return buddhistYear;
        if (match[1] === "mm_ts") return month;

        if (Object.prototype.hasOwnProperty.call(conditionalSamples, match[1])) {
          hasConditional = true;
          return conditionalSamples[match[1]];
        }

        hasUnsupported = true;
        return tok;
      })
      .join("");

    return { text, hasUnsupported, hasConditional };
  };

  renderRunningFormatEditor = (field, ref) => {
    const value = this.state[field] || "";
    const preview = this.buildFormatPreview(value);
    const hasRunningKey = /\{running_\d+\}/.test(value);

    return (
      <>
        <input
          type="text"
          ref={ref}
          className="form-control fw-bold"
          style={{ backgroundColor: "#f8faff", borderColor: "#cddbfe", color: "#4f46e5" }}
          value={value}
          onChange={(e) => this.setState({ [field]: e.target.value })}
          onKeyDown={(e) => this.handleFormatKeyDown(field, e)}
        />
        <div className="d-flex flex-wrap gap-1 mt-2">
          {this.getRunningFormatKeys().map((k) => {
            const disabled = k.isRunning && hasRunningKey;
            return (
              <button
                type="button"
                key={k.key}
                title={disabled ? t("rn_key_running_already_used") : k.desc}
                disabled={disabled}
                className={`btn btn-sm ${k.conditional ? "btn-outline-info" : k.supported ? "btn-outline-primary" : "btn-outline-warning"}`}
                style={{ fontSize: "11px", padding: "2px 8px", opacity: disabled ? 0.4 : 1 }}
                onClick={() => this.insertFormatKey(field, ref, k.key)}
              >
                {`{${k.key}}`}
              </button>
            );
          })}
        </div>
        <div className="mt-2 p-2 rounded-3 bg-light border">
          <div className="text-muted" style={{ fontSize: "11px" }}>
            {t("rn_example_result")}
          </div>
          <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
            {preview.text || "-"}
          </div>
          {preview.hasConditional && (
            <div className="text-info mt-1" style={{ fontSize: "11px" }}>
              <span className="icon me-1">{""}</span>
              {t("rn_conditional_warning")}
            </div>
          )}
          {preview.hasUnsupported && (
            <div className="text-warning mt-1" style={{ fontSize: "11px" }}>
              <span className="icon me-1">{""}</span>
              {t("rn_unsupported_warning")}
            </div>
          )}
        </div>
      </>
    );
  };

  // ─── แท็บ "อีเมล" - ผู้รับสำเนาเอกสารงาน ─────────────────────────────────
  // ทุกอีเมลในรายการนี้จะถูกใส่เป็น CC ตอนช่างส่ง Service Report + ใบกำกับภาษี
  // เฉพาะงานที่มีการชำระเงินเท่านั้น (ฝั่ง backend เป็นคนตัดสิน ดู sendServiceDocuments)
  EMAIL_ENDPOINT = "admin/email-recipients";

  GetEmailRecipients = async () => {
    loading(true);
    const result = await GET(this.EMAIL_ENDPOINT, { page_size: 100, page: 1 });
    this.setState({ data_email: this.sortBySequence(result?.status ? result.data : []) });
    loading(false);
  };

  handleEmailFormChange = (field, value) => {
    this.setState((prev) => ({ email_form: { ...prev.email_form, [field]: value } }));
  };

  handleEditEmailRecipient = (item) => {
    this.setState({
      email_form: {
        uid: item?.uid || "",
        name: item?.name || "",
        email: item?.email || "",
        is_active: item?.is_active !== false,
      },
    });
  };

  handleCancelEmailRecipient = () => {
    this.setState({ email_form: { uid: "", name: "", email: "", is_active: true } });
  };

  SaveEmailRecipient = async () => {
    const { email_form, data_email } = this.state;
    const email = (email_form.email || "").trim();

    if (!email) {
      alert("", "warning", t("warning"), t("email_recipient_email_required"));
      return;
    }
    // กันพิมพ์ผิดตั้งแต่หน้าเว็บ - backend ตรวจซ้ำอีกชั้นด้วย zod
    if (!/^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/.test(email)) {
      alert("", "warning", t("warning"), t("email_recipient_email_invalid"));
      return;
    }

    loading(true);
    const body = {
      company_id: company?.id || "",
      name: (email_form.name || "").trim(),
      email,
      recipient_type: "accounting",
      sequence: email_form.uid ? undefined : data_email.length + 1,
      is_active: email_form.is_active !== false,
    };

    const result = !email_form.uid
      ? await POST(this.EMAIL_ENDPOINT, body)
      : await PUT(this.EMAIL_ENDPOINT + "/" + email_form.uid, body);

    if (result?.status) {
      alert("", "success", t("success"), t("save_success"));
      this.handleCancelEmailRecipient();
      await this.GetEmailRecipients();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  ToggleEmailRecipient = async (item) => {
    loading(true);
    const result = await PUT(this.EMAIL_ENDPOINT + "/" + item.uid, { is_active: !(item.is_active !== false) });
    if (result?.status) await this.GetEmailRecipients();
    else alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    loading(false);
  };

  DeleteEmailRecipient = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    loading(true);
    const result = await DELETE(this.EMAIL_ENDPOINT + "/" + item.uid, null);
    if (result?.status) {
      alert("", "success", t("success"), t("delete_success"));
      if (this.state.email_form.uid === item.uid) this.handleCancelEmailRecipient();
      await this.GetEmailRecipients();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  renderEmailSettings = () => {
    const { data_email, email_form } = this.state;
    const isEditing = !!email_form.uid;

    return (
      <div className="row g-4">
        <div className="col-12">
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
            <div className="d-flex align-items-start mb-4">
              <span
                className="d-flex align-items-center justify-content-center rounded-2 fw-bold text-white me-3 flex-shrink-0"
                style={{ width: 26, height: 26, backgroundColor: "#2563eb", fontSize: 13 }}
              >
                <span className="icon">{"\uf0e0"}</span>
              </span>
              <div>
                <h6 className="fw-bold mb-1 text-dark">{t("email_recipient_title")}</h6>
                <div className="text-secondary text-12">{t("email_recipient_desc")}</div>
              </div>
            </div>

            {/* ฟอร์มเพิ่ม/แก้ไข */}
            <div className="row g-3 align-items-end mb-4">
              <div className="col-md-4">
                <label className="form-label small fw-bold text-secondary mb-1">{t("email_recipient_name")}</label>
                <input
                  className="form-control"
                  value={email_form.name}
                  placeholder={t("email_recipient_name_placeholder")}
                  onChange={(e) => this.handleEmailFormChange("name", e.target.value)}
                />
              </div>
              <div className="col-md-5">
                <label className="form-label small fw-bold text-secondary mb-1">
                  {t("email_recipient_email")} <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="email"
                  value={email_form.email}
                  placeholder="accounting@company.com"
                  onChange={(e) => this.handleEmailFormChange("email", e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                {(isEditing ? can("email-recipient.update") : can("email-recipient.create")) && (
                  <button
                    className="btn btn-primary fw-bold text-white flex-grow-1"
                    onClick={this.SaveEmailRecipient}
                  >
                    {isEditing ? t("save") : t("add")}
                  </button>
                )}
                {isEditing && (
                  <button className="btn btn-light border" onClick={this.handleCancelEmailRecipient}>
                    {t("cancel")}
                  </button>
                )}
              </div>
            </div>

            {/* รายการอีเมล */}
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: 60 }} className="text-center">#</th>
                    <th>{t("email_recipient_name")}</th>
                    <th>{t("email_recipient_email")}</th>
                    <th style={{ width: 120 }} className="text-center">{t("status")}</th>
                    <th style={{ width: 120 }} className="text-center">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data_email.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center text-secondary py-4">
                        {t("email_recipient_empty")}
                      </td>
                    </tr>
                  )}
                  {data_email.map((item, index) => (
                    <tr key={item.uid} className={email_form.uid === item.uid ? "table-primary" : ""}>
                      <td className="text-center text-secondary">{index + 1}</td>
                      <td className="fw-bold">{item.name || "-"}</td>
                      <td>{item.email}</td>
                      <td className="text-center">
                        <button
                          className={`btn btn-sm rounded-pill px-3 ${item.is_active !== false ? "btn-success-light text-success" : "btn-light text-secondary border"}`}
                          onClick={() => this.ToggleEmailRecipient(item)}
                          disabled={!can("email-recipient.update")}
                        >
                          {item.is_active !== false ? t("active") : t("inactive")}
                        </button>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          {can("email-recipient.update") && (
                            <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.handleEditEmailRecipient(item)} />
                          )}
                          {can("email-recipient.delete") && (
                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.DeleteEmailRecipient(item)} />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-primary-light px-3 pt-3 pb-2 rounded-4 text-primary mb-4" style={{ borderLeft: "4px solid #3b82f6" }}>
            <b>{t("email_recipient_rules_title")}</b>
            <small className="d-block text-muted">{t("email_recipient_rules_hint")}</small>
          </div>
        </div>
      </div>
    );
  };

  // ─── แท็บ "จัดกลุ่มเครื่องจักร" ───────────────────────────────────────────
  // master ของช่อง "ระบบ" ในฟอร์มขึ้นทะเบียนเครื่องจักร - รหัสกลุ่มถูกใช้เป็นส่วนหนึ่งของรหัสเครื่องจักร
  MACHINE_GROUP_ENDPOINT = "admin/machine-groups";
  MACHINE_GROUP_FORM_DEFAULT = { uid: "", code: "", name_th: "", name_en: "", is_active: true };

  GetMachineGroups = async () => {
    loading(true);
    const result = await GET(this.MACHINE_GROUP_ENDPOINT, { page_size: 100, page: 1 });
    this.setState({ data_machine_group: this.sortBySequence(result?.status ? result.data : []) });
    loading(false);
  };

  handleMachineGroupFormChange = (field, value) => {
    this.setState((prev) => ({ machine_group_form: { ...prev.machine_group_form, [field]: value } }));
  };

  handleEditMachineGroup = (item) => {
    this.setState({
      machine_group_form: {
        uid: item?.uid || "",
        code: item?.code || "",
        name_th: item?.name_th || "",
        name_en: item?.name_en || "",
        is_active: item?.is_active !== false,
      },
    });
  };

  handleCancelMachineGroup = () => {
    this.setState({ machine_group_form: { ...this.MACHINE_GROUP_FORM_DEFAULT } });
  };

  SaveMachineGroup = async () => {
    const { machine_group_form, data_machine_group } = this.state;
    const code = (machine_group_form.code || "").trim().toUpperCase();
    const name_th = (machine_group_form.name_th || "").trim();

    if (!code) {
      alert("", "warning", t("warning"), t("machine_group_code_required"));
      return;
    }
    if (!name_th) {
      alert("", "warning", t("warning"), t("machine_group_name_required"));
      return;
    }

    loading(true);
    const body = {
      company_id: company?.id || "",
      code,
      name_th,
      name_en: (machine_group_form.name_en || "").trim(),
      sequence: machine_group_form.uid ? undefined : data_machine_group.length + 1,
      is_active: machine_group_form.is_active !== false,
    };

    const result = !machine_group_form.uid
      ? await POST(this.MACHINE_GROUP_ENDPOINT, body)
      : await PUT(this.MACHINE_GROUP_ENDPOINT + "/" + machine_group_form.uid, body);

    if (result?.status) {
      alert("", "success", t("success"), t("save_success"));
      this.handleCancelMachineGroup();
      await this.GetMachineGroups();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  ToggleMachineGroup = async (item) => {
    loading(true);
    const result = await PUT(this.MACHINE_GROUP_ENDPOINT + "/" + item.uid, { is_active: !(item.is_active !== false) });
    if (result?.status) await this.GetMachineGroups();
    else alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    loading(false);
  };

  DeleteMachineGroup = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    loading(true);
    const result = await DELETE(this.MACHINE_GROUP_ENDPOINT + "/" + item.uid, null);
    if (result?.status) {
      alert("", "success", t("success"), t("delete_success"));
      if (this.state.machine_group_form.uid === item.uid) this.handleCancelMachineGroup();
      await this.GetMachineGroups();
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  renderMachineGroupSettings = () => {
    const { data_machine_group, machine_group_form } = this.state;
    const isEditing = !!machine_group_form.uid;

    return (
      <div className="row g-4">
        <div className="col-12">
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
            <div className="d-flex align-items-start mb-4">
              <span
                className="d-flex align-items-center justify-content-center rounded-2 fw-bold text-white me-3 flex-shrink-0"
                style={{ width: 26, height: 26, backgroundColor: "#2563eb", fontSize: 13 }}
              >
                <span className="icon">{"\uf085"}</span>
              </span>
              <div>
                <h6 className="fw-bold mb-1 text-dark">{t("machine_group_title")}</h6>
                <div className="text-secondary text-12">{t("machine_group_desc")}</div>
              </div>
            </div>

            {/* ฟอร์มเพิ่ม/แก้ไข */}
            <div className="row g-3 align-items-end mb-4">
              <div className="col-md-2">
                <label className="form-label small fw-bold text-secondary mb-1">
                  {t("machine_group_code")} <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control text-uppercase"
                  value={machine_group_form.code}
                  maxLength={20}
                  placeholder="TRF"
                  onChange={(e) => this.handleMachineGroupFormChange("code", e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold text-secondary mb-1">
                  {t("name_th")} <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={machine_group_form.name_th}
                  maxLength={200}
                  onChange={(e) => this.handleMachineGroupFormChange("name_th", e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small fw-bold text-secondary mb-1">{t("name_en")}</label>
                <input
                  className="form-control"
                  value={machine_group_form.name_en}
                  maxLength={200}
                  onChange={(e) => this.handleMachineGroupFormChange("name_en", e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                {(isEditing ? can("machine-group.update") : can("machine-group.create")) && (
                  <button
                    className="btn btn-primary fw-bold text-white flex-grow-1"
                    onClick={this.SaveMachineGroup}
                  >
                    {isEditing ? t("save") : t("add")}
                  </button>
                )}
                {isEditing && (
                  <button className="btn btn-light border" onClick={this.handleCancelMachineGroup}>
                    {t("cancel")}
                  </button>
                )}
              </div>
            </div>

            {/* รายการกลุ่มเครื่องจักร */}
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: 60 }} className="text-center">#</th>
                    <th style={{ width: 140 }}>{t("machine_group_code")}</th>
                    <th>{t("name_th")}</th>
                    <th>{t("name_en")}</th>
                    <th style={{ width: 120 }} className="text-center">{t("status")}</th>
                    <th style={{ width: 120 }} className="text-center">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data_machine_group.length === 0 && (
                    <tr>
                      <td colSpan={6} className="text-center text-secondary py-4">
                        {t("machine_group_empty")}
                      </td>
                    </tr>
                  )}
                  {data_machine_group.map((item, index) => (
                    <tr key={item.uid} className={machine_group_form.uid === item.uid ? "table-primary" : ""}>
                      <td className="text-center text-secondary">{index + 1}</td>
                      <td className="fw-bold">{item.code}</td>
                      <td>{item.name_th}</td>
                      <td>{item.name_en || "-"}</td>
                      <td className="text-center">
                        <button
                          className={`btn btn-sm rounded-pill px-3 ${item.is_active !== false ? "btn-success-light text-success" : "btn-light text-secondary border"}`}
                          onClick={() => this.ToggleMachineGroup(item)}
                          disabled={!can("machine-group.update")}
                        >
                          {item.is_active !== false ? t("active") : t("inactive")}
                        </button>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          {can("machine-group.update") && (
                            <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.handleEditMachineGroup(item)} />
                          )}
                          {can("machine-group.delete") && (
                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.DeleteMachineGroup(item)} />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-primary-light px-3 pt-3 pb-2 rounded-4 text-primary mb-4" style={{ borderLeft: "4px solid #3b82f6" }}>
            <b>{t("machine_group_rules_title")}</b>
            <small className="d-block text-muted">{t("machine_group_rules_hint")}</small>
          </div>
        </div>
      </div>
    );
  };

  renderRunningNumberSettings = () => {
    return (
      <div className="row g-4">
        <div className="col-12">
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border">
            <div className="d-flex align-items-start mb-4">
              <span
                className="d-flex align-items-center justify-content-center rounded-2 fw-bold text-white me-3 flex-shrink-0"
                style={{ width: 26, height: 26, backgroundColor: "#2563eb", fontSize: 13 }}
              >
                <span className="icon">{""}</span>
              </span>
              <div>
                <h6 className="fw-bold mb-1 text-dark">{t("rn_title")}</h6>
                <div className="text-secondary text-12">{t("rn_desc")}</div>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label small fw-bold text-secondary mb-1">{t("rn_asset_id_format_label")}</label>
                {this.renderRunningFormatEditor("asset_running_format", this.assetFormatInputRef)}
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold text-secondary mb-1">{t("rn_invoice_no_format_label")}</label>
                {this.renderRunningFormatEditor("invoice_running_format", this.invoiceFormatInputRef)}
              </div>
            </div>
          </div>

          <div className="bg-primary-light px-3 pt-3 pb-2 rounded-4 text-primary mb-4" style={{ borderLeft: "4px solid #3b82f6" }}>
            <b>{t("rn_rules_title")}</b>
            <small className="d-block text-muted mb-1">{t("rn_rules_hint")}</small>
            <br />
            <ul>
              {this.getRunningFormatKeys().map((k) => (
                <li key={k.key}>
                  <b>{`{${k.key}}`}</b> - {k.desc}{" "}
                  <span
                    className={`badge ${k.conditional ? "bg-info-light text-info" : k.supported ? "bg-success-light text-success" : "bg-warning-light text-warning"}`}
                    style={{ fontSize: "10px" }}
                  >
                    {k.conditional ? t("rn_key_conditional_badge") : k.supported ? t("rn_key_supported_badge") : t("rn_key_unsupported_badge")}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end gap-2 mb-4">
            {can("wr-running-number.update") && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                onClick={this.SaveRunningNumberSettings}
              >
                <span className="icon me-2">{""}</span> {t("save")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { active_tab } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          
          {/* Page Header */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark d-flex align-items-center">
              <span className="icon me-2 text-secondary">{"\uf013"}</span> {t("wr_configuration")}
            </h3>
            <div className="text-secondary text-14">{t("wr_config_desc")}</div>
          </div>

          {/* Top Navigation Tabs - grid ช่องเท่ากันทุกแท็บ เต็มความกว้าง ตัดขึ้นแถวใหม่อัตโนมัติเมื่อจอแคบ */}
          <div
            className="bg-white p-2 rounded-4 shadow-sm border mb-4"
            style={{
              borderColor: "#E9EDF7",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
              gap: "8px",
            }}
          >
            {SETTING_TABS.map((tab) => {
              const isActive = active_tab === tab.key;
              const count = tab.dataKey ? (this.state[tab.dataKey] || []).length : null;
              return (
                <button
                  key={tab.key}
                  type="button"
                  className={`btn btn-sm rounded-pill fw-bold px-3 py-2 d-flex align-items-center justify-content-center w-100 transition-all ${isActive ? "btn-primary shadow-sm" : "btn-white text-secondary border-0"}`}
                  title={t(tab.label)}
                  onClick={() => this.handleTabChange(tab.key)}
                >
                  <span className={`icon me-2 ${!isActive && tab.iconClass ? tab.iconClass : ""}`}>{tab.icon}</span>
                  <span className="text-truncate">{t(tab.label)}</span>
                  {count !== null && (
                    <span className={`badge ms-2 rounded-pill ${isActive ? "bg-white text-primary" : "bg-light text-secondary"}`}>{count}</span>
                  )}
                </button>
              );
            })}
          </div>

          {/* Main Content */}
          {active_tab === "travel_allowance" ? (
            this.renderTravelAllowance()
          ) : active_tab === "running_number" ? (
            this.renderRunningNumberSettings()
          ) : active_tab === "email" ? (
            this.renderEmailSettings()
          ) : active_tab === "machine_group" ? (
            this.renderMachineGroupSettings()
          ) : (
            /* Main Grid: Left List & Right Form */
            <div className="row g-4">
              <div className="col-lg-6 col-xl-5">
                {this.renderLeftPanel()}
              </div>
              <div className="col-lg-6 col-xl-7">
                {this.renderRightForm()}
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }
}
